/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as appIndexRouteImport } from './routes/(app)/index'
import { Route as unauthenticatedTermsRouteImport } from './routes/(unauthenticated)/terms'
import { Route as unauthenticatedSignupRouteImport } from './routes/(unauthenticated)/signup'
import { Route as unauthenticatedIdpLoginRouteImport } from './routes/(unauthenticated)/idp-login'
import { Route as unauthenticatedAuthErrorRouteImport } from './routes/(unauthenticated)/auth-error'
import { Route as unauthenticatedOrganizationSelectorIndexRouteImport } from './routes/(unauthenticated)/organization-selector/index'
import { Route as unauthenticatedLoginIndexRouteImport } from './routes/(unauthenticated)/login/index'
import { Route as unauthenticatedLinkIdentityIndexRouteImport } from './routes/(unauthenticated)/link-identity/index'
import { Route as appProfileIndexRouteImport } from './routes/(app)/profile/index'
import { Route as appOrgIndexRouteImport } from './routes/(app)/org/index'
import { Route as appInvitesIndexRouteImport } from './routes/(app)/invites/index'
import { Route as unauthenticatedOrganizationsStartRouteImport } from './routes/(unauthenticated)/organizations/start'
import { Route as unauthenticatedOrganizationsNotAMemberRouteImport } from './routes/(unauthenticated)/organizations/not-a-member'
import { Route as unauthenticatedLinkIdentityCallbackRouteImport } from './routes/(unauthenticated)/link-identity/callback'
import { Route as appInvitesAutoAcceptRouteImport } from './routes/(app)/invites/auto-accept'
import { Route as unauthenticatedOrganizationsInvitesRouteRouteImport } from './routes/(unauthenticated)/organizations/invites/route'
import { Route as appOrgOrgRouteRouteImport } from './routes/(app)/org/$org/route'
import { Route as appOrgOrgIndexRouteImport } from './routes/(app)/org/$org/index'
import { Route as unauthenticatedOrganizationsInvitesAcceptRouteImport } from './routes/(unauthenticated)/organizations/invites/accept'
import { Route as appOrgIdOrgIdSplatRouteImport } from './routes/(app)/org-id/$orgId/$'
import { Route as appIntegrationsSlackCallbackRouteImport } from './routes/(app)/integrations/slack/callback'
import { Route as appIntegrationsJiraCallbackRouteImport } from './routes/(app)/integrations/jira/callback'
import { Route as appIntegrationsGithubCallbackRouteImport } from './routes/(app)/integrations/github/callback'
import { Route as appIntegrationsProviderCallbackRouteImport } from './routes/(app)/integrations/$provider/callback'
import { Route as appOrgOrgSettingsRouteRouteImport } from './routes/(app)/org/$org/settings/route'
import { Route as appOrgOrgLoopIntelligenceRouteRouteImport } from './routes/(app)/org/$org/loop-intelligence/route'
import { Route as appOrgOrgLoopRouteRouteImport } from './routes/(app)/org/$org/loop/route'
import { Route as appOrgOrgIntakeRouteRouteImport } from './routes/(app)/org/$org/intake/route'
import { Route as unauthenticatedOrganizationsInvitesErrorIndexRouteImport } from './routes/(unauthenticated)/organizations/invites/error/index'
import { Route as appOrgOrgVisualizationsIndexRouteImport } from './routes/(app)/org/$org/visualizations/index'
import { Route as appOrgOrgSirDebugIndexRouteImport } from './routes/(app)/org/$org/sir-debug/index'
import { Route as appOrgOrgSettingsIndexRouteImport } from './routes/(app)/org/$org/settings/index'
import { Route as appOrgOrgObjectivesIndexRouteImport } from './routes/(app)/org/$org/objectives/index'
import { Route as appOrgOrgNotificationsIndexRouteImport } from './routes/(app)/org/$org/notifications/index'
import { Route as appOrgOrgLoopIntelligenceIndexRouteImport } from './routes/(app)/org/$org/loop-intelligence/index'
import { Route as appOrgOrgIntakeIndexRouteImport } from './routes/(app)/org/$org/intake/index'
import { Route as appOrgOrgIdeaManagementIndexRouteImport } from './routes/(app)/org/$org/idea-management/index'
import { Route as appOrgOrgDemandIndexRouteImport } from './routes/(app)/org/$org/demand/index'
import { Route as appOrgOrgDashboardsIndexRouteImport } from './routes/(app)/org/$org/dashboards/index'
import { Route as appOrgOrgAllItemsIndexRouteImport } from './routes/(app)/org/$org/all-items/index'
import { Route as unauthenticatedPublishedV1TimelineLinkIdRouteImport } from './routes/(unauthenticated)/published/v1/timeline/$linkId'
import { Route as unauthenticatedPublishedV1SwimlaneLinkIdRouteImport } from './routes/(unauthenticated)/published/v1/swimlane/$linkId'
import { Route as appOrgOrgIntakePriorityFrameworksRouteImport } from './routes/(app)/org/$org/intake/priority-frameworks'
import { Route as appOrgOrgIntakeOverviewRouteImport } from './routes/(app)/org/$org/intake/overview'
import { Route as appOrgOrgIntakeCustomFieldsRouteImport } from './routes/(app)/org/$org/intake/custom-fields'
import { Route as appOrgOrgIdeaManagementSplatRouteImport } from './routes/(app)/org/$org/idea-management/$'
import { Route as appOrgOrgAuditEntityIdRouteImport } from './routes/(app)/org/$org/audit/$entityId'
import { Route as appOrgOrgSettingsWorkItemUsageRouteRouteImport } from './routes/(app)/org/$org/settings/work-item-usage/route'
import { Route as appOrgOrgSettingsUserManagementRouteRouteImport } from './routes/(app)/org/$org/settings/user-management/route'
import { Route as appOrgOrgSettingsTeamsRouteRouteImport } from './routes/(app)/org/$org/settings/teams/route'
import { Route as appOrgOrgSettingsSubscriptionsRouteRouteImport } from './routes/(app)/org/$org/settings/subscriptions/route'
import { Route as appOrgOrgSettingsSkillsRouteRouteImport } from './routes/(app)/org/$org/settings/skills/route'
import { Route as appOrgOrgSettingsRolesRouteRouteImport } from './routes/(app)/org/$org/settings/roles/route'
import { Route as appOrgOrgSettingsPeopleRouteRouteImport } from './routes/(app)/org/$org/settings/people/route'
import { Route as appOrgOrgSettingsOrganizationRouteRouteImport } from './routes/(app)/org/$org/settings/organization/route'
import { Route as appOrgOrgSettingsOpenPositionsRouteRouteImport } from './routes/(app)/org/$org/settings/open-positions/route'
import { Route as appOrgOrgSettingsOauthClientsRouteRouteImport } from './routes/(app)/org/$org/settings/oauth-clients/route'
import { Route as appOrgOrgSettingsLocationRouteRouteImport } from './routes/(app)/org/$org/settings/location/route'
import { Route as appOrgOrgSettingsDomainsRouteRouteImport } from './routes/(app)/org/$org/settings/domains/route'
import { Route as appOrgOrgSettingsCurrencyRouteRouteImport } from './routes/(app)/org/$org/settings/currency/route'
import { Route as appOrgOrgSettingsCreditsRouteRouteImport } from './routes/(app)/org/$org/settings/credits/route'
import { Route as appOrgOrgSettingsConnectionsRouteRouteImport } from './routes/(app)/org/$org/settings/connections/route'
import { Route as appOrgOrgSettingsCapacityRouteRouteImport } from './routes/(app)/org/$org/settings/capacity/route'
import { Route as appOrgOrgLoopLoopIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/route'
import { Route as appOrgOrgIntakePortalsRouteRouteImport } from './routes/(app)/org/$org/intake/portals/route'
import { Route as appOrgOrgIntakeInboxRouteRouteImport } from './routes/(app)/org/$org/intake/inbox/route'
import { Route as appOrgOrgSettingsWorkItemUsageIndexRouteImport } from './routes/(app)/org/$org/settings/work-item-usage/index'
import { Route as appOrgOrgSettingsWorkIntegrationsIndexRouteImport } from './routes/(app)/org/$org/settings/work-integrations/index'
import { Route as appOrgOrgSettingsUserManagementIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/index'
import { Route as appOrgOrgSettingsTeamsIndexRouteImport } from './routes/(app)/org/$org/settings/teams/index'
import { Route as appOrgOrgSettingsSubscriptionsIndexRouteImport } from './routes/(app)/org/$org/settings/subscriptions/index'
import { Route as appOrgOrgSettingsSkillsIndexRouteImport } from './routes/(app)/org/$org/settings/skills/index'
import { Route as appOrgOrgSettingsRolesIndexRouteImport } from './routes/(app)/org/$org/settings/roles/index'
import { Route as appOrgOrgSettingsPeopleIndexRouteImport } from './routes/(app)/org/$org/settings/people/index'
import { Route as appOrgOrgSettingsOrganizationIndexRouteImport } from './routes/(app)/org/$org/settings/organization/index'
import { Route as appOrgOrgSettingsOpenPositionsIndexRouteImport } from './routes/(app)/org/$org/settings/open-positions/index'
import { Route as appOrgOrgSettingsOauthClientsIndexRouteImport } from './routes/(app)/org/$org/settings/oauth-clients/index'
import { Route as appOrgOrgSettingsNotificationsIndexRouteImport } from './routes/(app)/org/$org/settings/notifications/index'
import { Route as appOrgOrgSettingsLocationIndexRouteImport } from './routes/(app)/org/$org/settings/location/index'
import { Route as appOrgOrgSettingsItemTypesIndexRouteImport } from './routes/(app)/org/$org/settings/item-types/index'
import { Route as appOrgOrgSettingsEffortEstimationIndexRouteImport } from './routes/(app)/org/$org/settings/effort-estimation/index'
import { Route as appOrgOrgSettingsDomainsIndexRouteImport } from './routes/(app)/org/$org/settings/domains/index'
import { Route as appOrgOrgSettingsCustomItemStatusIndexRouteImport } from './routes/(app)/org/$org/settings/custom-item-status/index'
import { Route as appOrgOrgSettingsCustomFieldsIndexRouteImport } from './routes/(app)/org/$org/settings/custom-fields/index'
import { Route as appOrgOrgSettingsCurrencyIndexRouteImport } from './routes/(app)/org/$org/settings/currency/index'
import { Route as appOrgOrgSettingsCreditsIndexRouteImport } from './routes/(app)/org/$org/settings/credits/index'
import { Route as appOrgOrgSettingsConnectionsIndexRouteImport } from './routes/(app)/org/$org/settings/connections/index'
import { Route as appOrgOrgSettingsCapacityIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/index'
import { Route as appOrgOrgSettingsAuditIndexRouteImport } from './routes/(app)/org/$org/settings/audit/index'
import { Route as appOrgOrgSettingsAccountingSandboxIndexRouteImport } from './routes/(app)/org/$org/settings/accounting-sandbox/index'
import { Route as appOrgOrgLoopLoopIdIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/index'
import { Route as appOrgOrgIntakeProductAreasIndexRouteImport } from './routes/(app)/org/$org/intake/product-areas/index'
import { Route as appOrgOrgIntakePortalsIndexRouteImport } from './routes/(app)/org/$org/intake/portals/index'
import { Route as appOrgOrgIntakeInboxIndexRouteImport } from './routes/(app)/org/$org/intake/inbox/index'
import { Route as appOrgOrgIntakeIdeasIndexRouteImport } from './routes/(app)/org/$org/intake/ideas/index'
import { Route as appOrgOrgIntakeDemandsIndexRouteImport } from './routes/(app)/org/$org/intake/demands/index'
import { Route as appOrgOrgIntakeCustomersIndexRouteImport } from './routes/(app)/org/$org/intake/customers/index'
import { Route as appOrgOrgDashboardsDashboardIdIndexRouteImport } from './routes/(app)/org/$org/dashboards/$dashboardId/index'
import { Route as appOrgOrgSettingsOpenPositionsHiredRouteImport } from './routes/(app)/org/$org/settings/open-positions/hired'
import { Route as appOrgOrgSettingsOauthClientsIdRouteImport } from './routes/(app)/org/$org/settings/oauth-clients/$id'
import { Route as appOrgOrgSettingsNotificationsSlack_app_healthRouteImport } from './routes/(app)/org/$org/settings/notifications/slack_app_health'
import { Route as appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteImport } from './routes/(app)/org/$org/settings/work-integrations/$integrationId/route'
import { Route as appOrgOrgSettingsUserManagementUsersRouteRouteImport } from './routes/(app)/org/$org/settings/user-management/users/route'
import { Route as appOrgOrgSettingsNotificationsSubscriptionsRouteRouteImport } from './routes/(app)/org/$org/settings/notifications/subscriptions/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/route'
import { Route as appOrgOrgLoopLoopIdTeamsRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/teams/route'
import { Route as appOrgOrgLoopLoopIdPortfolioRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/route'
import { Route as appOrgOrgLoopLoopIdPlannerRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/route'
import { Route as appOrgOrgLoopLoopIdDashboardRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/dashboard/route'
import { Route as appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRouteImport } from './routes/(app)/org/$org/settings/work-integrations/$integrationId/index'
import { Route as appOrgOrgSettingsUserManagementUsersIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/users/index'
import { Route as appOrgOrgSettingsUserManagementInvitesIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/invites/index'
import { Route as appOrgOrgSettingsNotificationsSubscriptionsIndexRouteImport } from './routes/(app)/org/$org/settings/notifications/subscriptions/index'
import { Route as appOrgOrgSettingsCapacityWorkloadSchemeIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/workload-scheme/index'
import { Route as appOrgOrgSettingsCapacityOrphanedDataIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/orphaned-data/index'
import { Route as appOrgOrgSettingsCapacityHolidaySchemeIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/holiday-scheme/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/index'
import { Route as appOrgOrgLoopLoopIdTeamsIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/teams/index'
import { Route as appOrgOrgLoopLoopIdStrategyIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/strategy/index'
import { Route as appOrgOrgLoopLoopIdPortfolioIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/index'
import { Route as appOrgOrgLoopLoopIdPlannerIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/index'
import { Route as appOrgOrgLoopLoopIdOverviewIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/overview/index'
import { Route as appOrgOrgLoopLoopIdLoopIntelligenceIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/loop-intelligence/index'
import { Route as appOrgOrgLoopLoopIdIntelligenceIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/intelligence/index'
import { Route as appOrgOrgLoopLoopIdIntegrationsIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/integrations/index'
import { Route as appOrgOrgLoopLoopIdFinancialsIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/financials/index'
import { Route as appOrgOrgLoopLoopIdDashboardIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/dashboard/index'
import { Route as appOrgOrgIntakeProductAreasCreateIndexRouteImport } from './routes/(app)/org/$org/intake/product-areas/create/index'
import { Route as appOrgOrgIntakeProductAreasProductAreaIdIndexRouteImport } from './routes/(app)/org/$org/intake/product-areas/$productAreaId/index'
import { Route as appOrgOrgIntakePortalsCreateIndexRouteImport } from './routes/(app)/org/$org/intake/portals/create/index'
import { Route as appOrgOrgIntakePortalsPortalIdIndexRouteImport } from './routes/(app)/org/$org/intake/portals/$portalId/index'
import { Route as appOrgOrgIntakeIdeasViewIndexRouteImport } from './routes/(app)/org/$org/intake/ideas/view/index'
import { Route as appOrgOrgIntakeIdeasCreateIndexRouteImport } from './routes/(app)/org/$org/intake/ideas/create/index'
import { Route as appOrgOrgIntakeIdeasCompletedIndexRouteImport } from './routes/(app)/org/$org/intake/ideas/completed/index'
import { Route as appOrgOrgIntakeIdeasAllIndexRouteImport } from './routes/(app)/org/$org/intake/ideas/all/index'
import { Route as appOrgOrgIntakeDemandsViewsIndexRouteImport } from './routes/(app)/org/$org/intake/demands/views/index'
import { Route as appOrgOrgIntakeDemandsStatusesIndexRouteImport } from './routes/(app)/org/$org/intake/demands/statuses/index'
import { Route as appOrgOrgDashboardsGeneratedDashboardIdIndexRouteImport } from './routes/(app)/org/$org/dashboards/generated/$dashboardId/index'
import { Route as unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/svg/route'
import { Route as unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/png/route'
import { Route as appOrgOrgSettingsTeamsTeamTeamIdRouteRouteImport } from './routes/(app)/org/$org/settings/teams/team/$teamId/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/route'
import { Route as appOrgOrgLoopLoopIdPlannerLiveRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/live/route'
import { Route as appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRouteImport } from './routes/(app)/org/$org/settings/work-integrations/$integrationId/logs/index'
import { Route as appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRouteImport } from './routes/(app)/org/$org/settings/work-integrations/$integrationId/issues/index'
import { Route as appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/users/$userId/index'
import { Route as appOrgOrgSettingsTeamsTeamTeamIdIndexRouteImport } from './routes/(app)/org/$org/settings/teams/team/$teamId/index'
import { Route as appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRouteImport } from './routes/(app)/org/$org/settings/notifications/subscriptions/idea-manager/index'
import { Route as appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/index'
import { Route as appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/index'
import { Route as appOrgOrgLoopLoopIdStrategyManageIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/strategy/manage/index'
import { Route as appOrgOrgLoopLoopIdPortfolioTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/timeline/index'
import { Route as appOrgOrgLoopLoopIdPortfolioTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/table/index'
import { Route as appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/swimlane/index'
import { Route as appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/node-graph/index'
import { Route as appOrgOrgLoopLoopIdPlannerLiveIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/live/index'
import { Route as appOrgOrgLoopLoopIdDashboardDeliverablesIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/dashboard/deliverables/index'
import { Route as appOrgOrgIntakePortalsPortalIdFormIdIndexRouteImport } from './routes/(app)/org/$org/intake/portals/$portalId/$formId/index'
import { Route as appOrgOrgIntakeIdeasViewViewIdIndexRouteImport } from './routes/(app)/org/$org/intake/ideas/view/$viewId/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/route'
import { Route as appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/route'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/timeline/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/table/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/main/node-graph/index'
import { Route as appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/index'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/index'
import { Route as appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/live/timeline/index'
import { Route as appOrgOrgLoopLoopIdPlannerLiveTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/live/table/index'
import { Route as appOrgOrgIntakeDemandsViewsViewViewIdIndexRouteImport } from './routes/(app)/org/$org/intake/demands/views/view/$viewId/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/index'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph/index'
import { Route as appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/index'
import { Route as appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/table/index'
import { Route as appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane/index'
import { Route as appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/index'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/index'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/index'
import { Route as appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRouteImport } from './routes/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/index'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg/route'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png/route'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf/route'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg/route'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png/route'
import { Route as unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRouteImport } from './routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId/route'
import { Route as appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRouteImport } from './routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId/route'

const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const appIndexRoute = appIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appRouteRoute,
} as any)
const unauthenticatedTermsRoute = unauthenticatedTermsRouteImport.update({
  id: '/(unauthenticated)/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthenticatedSignupRoute = unauthenticatedSignupRouteImport.update({
  id: '/(unauthenticated)/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthenticatedIdpLoginRoute = unauthenticatedIdpLoginRouteImport.update({
  id: '/(unauthenticated)/idp-login',
  path: '/idp-login',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthenticatedAuthErrorRoute =
  unauthenticatedAuthErrorRouteImport.update({
    id: '/(unauthenticated)/auth-error',
    path: '/auth-error',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedOrganizationSelectorIndexRoute =
  unauthenticatedOrganizationSelectorIndexRouteImport.update({
    id: '/(unauthenticated)/organization-selector/',
    path: '/organization-selector/',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedLoginIndexRoute =
  unauthenticatedLoginIndexRouteImport.update({
    id: '/(unauthenticated)/login/',
    path: '/login/',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedLinkIdentityIndexRoute =
  unauthenticatedLinkIdentityIndexRouteImport.update({
    id: '/(unauthenticated)/link-identity/',
    path: '/link-identity/',
    getParentRoute: () => rootRouteImport,
  } as any)
const appProfileIndexRoute = appProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => appRouteRoute,
} as any)
const appOrgIndexRoute = appOrgIndexRouteImport.update({
  id: '/org/',
  path: '/org/',
  getParentRoute: () => appRouteRoute,
} as any)
const appInvitesIndexRoute = appInvitesIndexRouteImport.update({
  id: '/invites/',
  path: '/invites/',
  getParentRoute: () => appRouteRoute,
} as any)
const unauthenticatedOrganizationsStartRoute =
  unauthenticatedOrganizationsStartRouteImport.update({
    id: '/(unauthenticated)/organizations/start',
    path: '/organizations/start',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedOrganizationsNotAMemberRoute =
  unauthenticatedOrganizationsNotAMemberRouteImport.update({
    id: '/(unauthenticated)/organizations/not-a-member',
    path: '/organizations/not-a-member',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedLinkIdentityCallbackRoute =
  unauthenticatedLinkIdentityCallbackRouteImport.update({
    id: '/(unauthenticated)/link-identity/callback',
    path: '/link-identity/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const appInvitesAutoAcceptRoute = appInvitesAutoAcceptRouteImport.update({
  id: '/invites/auto-accept',
  path: '/invites/auto-accept',
  getParentRoute: () => appRouteRoute,
} as any)
const unauthenticatedOrganizationsInvitesRouteRoute =
  unauthenticatedOrganizationsInvitesRouteRouteImport.update({
    id: '/(unauthenticated)/organizations/invites',
    path: '/organizations/invites',
    getParentRoute: () => rootRouteImport,
  } as any)
const appOrgOrgRouteRoute = appOrgOrgRouteRouteImport.update({
  id: '/org/$org',
  path: '/org/$org',
  getParentRoute: () => appRouteRoute,
} as any)
const appOrgOrgIndexRoute = appOrgOrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const unauthenticatedOrganizationsInvitesAcceptRoute =
  unauthenticatedOrganizationsInvitesAcceptRouteImport.update({
    id: '/accept',
    path: '/accept',
    getParentRoute: () => unauthenticatedOrganizationsInvitesRouteRoute,
  } as any)
const appOrgIdOrgIdSplatRoute = appOrgIdOrgIdSplatRouteImport.update({
  id: '/org-id/$orgId/$',
  path: '/org-id/$orgId/$',
  getParentRoute: () => appRouteRoute,
} as any)
const appIntegrationsSlackCallbackRoute =
  appIntegrationsSlackCallbackRouteImport.update({
    id: '/integrations/slack/callback',
    path: '/integrations/slack/callback',
    getParentRoute: () => appRouteRoute,
  } as any)
const appIntegrationsJiraCallbackRoute =
  appIntegrationsJiraCallbackRouteImport.update({
    id: '/integrations/jira/callback',
    path: '/integrations/jira/callback',
    getParentRoute: () => appRouteRoute,
  } as any)
const appIntegrationsGithubCallbackRoute =
  appIntegrationsGithubCallbackRouteImport.update({
    id: '/integrations/github/callback',
    path: '/integrations/github/callback',
    getParentRoute: () => appRouteRoute,
  } as any)
const appIntegrationsProviderCallbackRoute =
  appIntegrationsProviderCallbackRouteImport.update({
    id: '/integrations/$provider/callback',
    path: '/integrations/$provider/callback',
    getParentRoute: () => appRouteRoute,
  } as any)
const appOrgOrgSettingsRouteRoute = appOrgOrgSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgLoopIntelligenceRouteRoute =
  appOrgOrgLoopIntelligenceRouteRouteImport.update({
    id: '/loop-intelligence',
    path: '/loop-intelligence',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgLoopRouteRoute = appOrgOrgLoopRouteRouteImport.update({
  id: '/loop',
  path: '/loop',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgIntakeRouteRoute = appOrgOrgIntakeRouteRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const unauthenticatedOrganizationsInvitesErrorIndexRoute =
  unauthenticatedOrganizationsInvitesErrorIndexRouteImport.update({
    id: '/error/',
    path: '/error/',
    getParentRoute: () => unauthenticatedOrganizationsInvitesRouteRoute,
  } as any)
const appOrgOrgVisualizationsIndexRoute =
  appOrgOrgVisualizationsIndexRouteImport.update({
    id: '/visualizations/',
    path: '/visualizations/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgSirDebugIndexRoute = appOrgOrgSirDebugIndexRouteImport.update({
  id: '/sir-debug/',
  path: '/sir-debug/',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgSettingsIndexRoute = appOrgOrgSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgSettingsRouteRoute,
} as any)
const appOrgOrgObjectivesIndexRoute =
  appOrgOrgObjectivesIndexRouteImport.update({
    id: '/objectives/',
    path: '/objectives/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgNotificationsIndexRoute =
  appOrgOrgNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgLoopIntelligenceIndexRoute =
  appOrgOrgLoopIntelligenceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopIntelligenceRouteRoute,
  } as any)
const appOrgOrgIntakeIndexRoute = appOrgOrgIntakeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgIntakeRouteRoute,
} as any)
const appOrgOrgIdeaManagementIndexRoute =
  appOrgOrgIdeaManagementIndexRouteImport.update({
    id: '/idea-management/',
    path: '/idea-management/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgDemandIndexRoute = appOrgOrgDemandIndexRouteImport.update({
  id: '/demand/',
  path: '/demand/',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgDashboardsIndexRoute =
  appOrgOrgDashboardsIndexRouteImport.update({
    id: '/dashboards/',
    path: '/dashboards/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgAllItemsIndexRoute = appOrgOrgAllItemsIndexRouteImport.update({
  id: '/all-items/',
  path: '/all-items/',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const unauthenticatedPublishedV1TimelineLinkIdRoute =
  unauthenticatedPublishedV1TimelineLinkIdRouteImport.update({
    id: '/(unauthenticated)/published/v1/timeline/$linkId',
    path: '/published/v1/timeline/$linkId',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedPublishedV1SwimlaneLinkIdRoute =
  unauthenticatedPublishedV1SwimlaneLinkIdRouteImport.update({
    id: '/(unauthenticated)/published/v1/swimlane/$linkId',
    path: '/published/v1/swimlane/$linkId',
    getParentRoute: () => rootRouteImport,
  } as any)
const appOrgOrgIntakePriorityFrameworksRoute =
  appOrgOrgIntakePriorityFrameworksRouteImport.update({
    id: '/priority-frameworks',
    path: '/priority-frameworks',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeOverviewRoute = appOrgOrgIntakeOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => appOrgOrgIntakeRouteRoute,
} as any)
const appOrgOrgIntakeCustomFieldsRoute =
  appOrgOrgIntakeCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIdeaManagementSplatRoute =
  appOrgOrgIdeaManagementSplatRouteImport.update({
    id: '/idea-management/$',
    path: '/idea-management/$',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgAuditEntityIdRoute = appOrgOrgAuditEntityIdRouteImport.update({
  id: '/audit/$entityId',
  path: '/audit/$entityId',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgSettingsWorkItemUsageRouteRoute =
  appOrgOrgSettingsWorkItemUsageRouteRouteImport.update({
    id: '/work-item-usage',
    path: '/work-item-usage',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementRouteRoute =
  appOrgOrgSettingsUserManagementRouteRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsTeamsRouteRoute =
  appOrgOrgSettingsTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsSubscriptionsRouteRoute =
  appOrgOrgSettingsSubscriptionsRouteRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsSkillsRouteRoute =
  appOrgOrgSettingsSkillsRouteRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsRolesRouteRoute =
  appOrgOrgSettingsRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsPeopleRouteRoute =
  appOrgOrgSettingsPeopleRouteRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsOrganizationRouteRoute =
  appOrgOrgSettingsOrganizationRouteRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsOpenPositionsRouteRoute =
  appOrgOrgSettingsOpenPositionsRouteRouteImport.update({
    id: '/open-positions',
    path: '/open-positions',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsOauthClientsRouteRoute =
  appOrgOrgSettingsOauthClientsRouteRouteImport.update({
    id: '/oauth-clients',
    path: '/oauth-clients',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsLocationRouteRoute =
  appOrgOrgSettingsLocationRouteRouteImport.update({
    id: '/location',
    path: '/location',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsDomainsRouteRoute =
  appOrgOrgSettingsDomainsRouteRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCurrencyRouteRoute =
  appOrgOrgSettingsCurrencyRouteRouteImport.update({
    id: '/currency',
    path: '/currency',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCreditsRouteRoute =
  appOrgOrgSettingsCreditsRouteRouteImport.update({
    id: '/credits',
    path: '/credits',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsConnectionsRouteRoute =
  appOrgOrgSettingsConnectionsRouteRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityRouteRoute =
  appOrgOrgSettingsCapacityRouteRouteImport.update({
    id: '/capacity',
    path: '/capacity',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdRouteRoute =
  appOrgOrgLoopLoopIdRouteRouteImport.update({
    id: '/$loopId',
    path: '/$loopId',
    getParentRoute: () => appOrgOrgLoopRouteRoute,
  } as any)
const appOrgOrgIntakePortalsRouteRoute =
  appOrgOrgIntakePortalsRouteRouteImport.update({
    id: '/portals',
    path: '/portals',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeInboxRouteRoute =
  appOrgOrgIntakeInboxRouteRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgSettingsWorkItemUsageIndexRoute =
  appOrgOrgSettingsWorkItemUsageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsWorkItemUsageRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIndexRoute =
  appOrgOrgSettingsWorkIntegrationsIndexRouteImport.update({
    id: '/work-integrations/',
    path: '/work-integrations/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementIndexRoute =
  appOrgOrgSettingsUserManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgSettingsTeamsIndexRoute =
  appOrgOrgSettingsTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsTeamsRouteRoute,
  } as any)
const appOrgOrgSettingsSubscriptionsIndexRoute =
  appOrgOrgSettingsSubscriptionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsSubscriptionsRouteRoute,
  } as any)
const appOrgOrgSettingsSkillsIndexRoute =
  appOrgOrgSettingsSkillsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsSkillsRouteRoute,
  } as any)
const appOrgOrgSettingsRolesIndexRoute =
  appOrgOrgSettingsRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsRolesRouteRoute,
  } as any)
const appOrgOrgSettingsPeopleIndexRoute =
  appOrgOrgSettingsPeopleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsPeopleRouteRoute,
  } as any)
const appOrgOrgSettingsOrganizationIndexRoute =
  appOrgOrgSettingsOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsOrganizationRouteRoute,
  } as any)
const appOrgOrgSettingsOpenPositionsIndexRoute =
  appOrgOrgSettingsOpenPositionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsOpenPositionsRouteRoute,
  } as any)
const appOrgOrgSettingsOauthClientsIndexRoute =
  appOrgOrgSettingsOauthClientsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsOauthClientsRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsIndexRoute =
  appOrgOrgSettingsNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsLocationIndexRoute =
  appOrgOrgSettingsLocationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsLocationRouteRoute,
  } as any)
const appOrgOrgSettingsItemTypesIndexRoute =
  appOrgOrgSettingsItemTypesIndexRouteImport.update({
    id: '/item-types/',
    path: '/item-types/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsEffortEstimationIndexRoute =
  appOrgOrgSettingsEffortEstimationIndexRouteImport.update({
    id: '/effort-estimation/',
    path: '/effort-estimation/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsDomainsIndexRoute =
  appOrgOrgSettingsDomainsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsDomainsRouteRoute,
  } as any)
const appOrgOrgSettingsCustomItemStatusIndexRoute =
  appOrgOrgSettingsCustomItemStatusIndexRouteImport.update({
    id: '/custom-item-status/',
    path: '/custom-item-status/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCustomFieldsIndexRoute =
  appOrgOrgSettingsCustomFieldsIndexRouteImport.update({
    id: '/custom-fields/',
    path: '/custom-fields/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCurrencyIndexRoute =
  appOrgOrgSettingsCurrencyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsCurrencyRouteRoute,
  } as any)
const appOrgOrgSettingsCreditsIndexRoute =
  appOrgOrgSettingsCreditsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsCreditsRouteRoute,
  } as any)
const appOrgOrgSettingsConnectionsIndexRoute =
  appOrgOrgSettingsConnectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsConnectionsRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityIndexRoute =
  appOrgOrgSettingsCapacityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgSettingsAuditIndexRoute =
  appOrgOrgSettingsAuditIndexRouteImport.update({
    id: '/audit/',
    path: '/audit/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsAccountingSandboxIndexRoute =
  appOrgOrgSettingsAccountingSandboxIndexRouteImport.update({
    id: '/accounting-sandbox/',
    path: '/accounting-sandbox/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdIndexRoute =
  appOrgOrgLoopLoopIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgIntakeProductAreasIndexRoute =
  appOrgOrgIntakeProductAreasIndexRouteImport.update({
    id: '/product-areas/',
    path: '/product-areas/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakePortalsIndexRoute =
  appOrgOrgIntakePortalsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgIntakePortalsRouteRoute,
  } as any)
const appOrgOrgIntakeInboxIndexRoute =
  appOrgOrgIntakeInboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgIntakeInboxRouteRoute,
  } as any)
const appOrgOrgIntakeIdeasIndexRoute =
  appOrgOrgIntakeIdeasIndexRouteImport.update({
    id: '/ideas/',
    path: '/ideas/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeDemandsIndexRoute =
  appOrgOrgIntakeDemandsIndexRouteImport.update({
    id: '/demands/',
    path: '/demands/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeCustomersIndexRoute =
  appOrgOrgIntakeCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgDashboardsDashboardIdIndexRoute =
  appOrgOrgDashboardsDashboardIdIndexRouteImport.update({
    id: '/dashboards/$dashboardId/',
    path: '/dashboards/$dashboardId/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgSettingsOpenPositionsHiredRoute =
  appOrgOrgSettingsOpenPositionsHiredRouteImport.update({
    id: '/hired',
    path: '/hired',
    getParentRoute: () => appOrgOrgSettingsOpenPositionsRouteRoute,
  } as any)
const appOrgOrgSettingsOauthClientsIdRoute =
  appOrgOrgSettingsOauthClientsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => appOrgOrgSettingsOauthClientsRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsSlack_app_healthRoute =
  appOrgOrgSettingsNotificationsSlack_app_healthRouteImport.update({
    id: '/notifications/slack_app_health',
    path: '/notifications/slack_app_health',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteImport.update({
    id: '/work-integrations/$integrationId',
    path: '/work-integrations/$integrationId',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersRouteRoute =
  appOrgOrgSettingsUserManagementUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsSubscriptionsRouteRoute =
  appOrgOrgSettingsNotificationsSubscriptionsRouteRouteImport.update({
    id: '/notifications/subscriptions',
    path: '/notifications/subscriptions',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsRouteRouteImport.update({
    id: '/visualizations',
    path: '/visualizations',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdTeamsRouteRoute =
  appOrgOrgLoopLoopIdTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioRouteRoute =
  appOrgOrgLoopLoopIdPortfolioRouteRouteImport.update({
    id: '/portfolio',
    path: '/portfolio',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerRouteRoute =
  appOrgOrgLoopLoopIdPlannerRouteRouteImport.update({
    id: '/planner',
    path: '/planner',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdDashboardRouteRoute =
  appOrgOrgLoopLoopIdDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersIndexRoute =
  appOrgOrgSettingsUserManagementUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsUserManagementUsersRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementInvitesIndexRoute =
  appOrgOrgSettingsUserManagementInvitesIndexRouteImport.update({
    id: '/invites/',
    path: '/invites/',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsSubscriptionsIndexRoute =
  appOrgOrgSettingsNotificationsSubscriptionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsNotificationsSubscriptionsRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityWorkloadSchemeIndexRoute =
  appOrgOrgSettingsCapacityWorkloadSchemeIndexRouteImport.update({
    id: '/workload-scheme/',
    path: '/workload-scheme/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityOrphanedDataIndexRoute =
  appOrgOrgSettingsCapacityOrphanedDataIndexRouteImport.update({
    id: '/orphaned-data/',
    path: '/orphaned-data/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityHolidaySchemeIndexRoute =
  appOrgOrgSettingsCapacityHolidaySchemeIndexRouteImport.update({
    id: '/holiday-scheme/',
    path: '/holiday-scheme/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdTeamsIndexRoute =
  appOrgOrgLoopLoopIdTeamsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdTeamsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdStrategyIndexRoute =
  appOrgOrgLoopLoopIdStrategyIndexRouteImport.update({
    id: '/strategy/',
    path: '/strategy/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioIndexRoute =
  appOrgOrgLoopLoopIdPortfolioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerIndexRoute =
  appOrgOrgLoopLoopIdPlannerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdOverviewIndexRoute =
  appOrgOrgLoopLoopIdOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdLoopIntelligenceIndexRoute =
  appOrgOrgLoopLoopIdLoopIntelligenceIndexRouteImport.update({
    id: '/loop-intelligence/',
    path: '/loop-intelligence/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdIntelligenceIndexRoute =
  appOrgOrgLoopLoopIdIntelligenceIndexRouteImport.update({
    id: '/intelligence/',
    path: '/intelligence/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdIntegrationsIndexRoute =
  appOrgOrgLoopLoopIdIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdFinancialsIndexRoute =
  appOrgOrgLoopLoopIdFinancialsIndexRouteImport.update({
    id: '/financials/',
    path: '/financials/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdDashboardIndexRoute =
  appOrgOrgLoopLoopIdDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdDashboardRouteRoute,
  } as any)
const appOrgOrgIntakeProductAreasCreateIndexRoute =
  appOrgOrgIntakeProductAreasCreateIndexRouteImport.update({
    id: '/product-areas/create/',
    path: '/product-areas/create/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeProductAreasProductAreaIdIndexRoute =
  appOrgOrgIntakeProductAreasProductAreaIdIndexRouteImport.update({
    id: '/product-areas/$productAreaId/',
    path: '/product-areas/$productAreaId/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakePortalsCreateIndexRoute =
  appOrgOrgIntakePortalsCreateIndexRouteImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => appOrgOrgIntakePortalsRouteRoute,
  } as any)
const appOrgOrgIntakePortalsPortalIdIndexRoute =
  appOrgOrgIntakePortalsPortalIdIndexRouteImport.update({
    id: '/$portalId/',
    path: '/$portalId/',
    getParentRoute: () => appOrgOrgIntakePortalsRouteRoute,
  } as any)
const appOrgOrgIntakeIdeasViewIndexRoute =
  appOrgOrgIntakeIdeasViewIndexRouteImport.update({
    id: '/ideas/view/',
    path: '/ideas/view/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeIdeasCreateIndexRoute =
  appOrgOrgIntakeIdeasCreateIndexRouteImport.update({
    id: '/ideas/create/',
    path: '/ideas/create/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeIdeasCompletedIndexRoute =
  appOrgOrgIntakeIdeasCompletedIndexRouteImport.update({
    id: '/ideas/completed/',
    path: '/ideas/completed/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeIdeasAllIndexRoute =
  appOrgOrgIntakeIdeasAllIndexRouteImport.update({
    id: '/ideas/all/',
    path: '/ideas/all/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeDemandsViewsIndexRoute =
  appOrgOrgIntakeDemandsViewsIndexRouteImport.update({
    id: '/demands/views/',
    path: '/demands/views/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgIntakeDemandsStatusesIndexRoute =
  appOrgOrgIntakeDemandsStatusesIndexRouteImport.update({
    id: '/demands/statuses/',
    path: '/demands/statuses/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgDashboardsGeneratedDashboardIdIndexRoute =
  appOrgOrgDashboardsGeneratedDashboardIdIndexRouteImport.update({
    id: '/dashboards/generated/$dashboardId/',
    path: '/dashboards/generated/$dashboardId/',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRoute =
  unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/svg',
      path: '/export/v1/loop-visualization/dashboard/$dashboardId/svg',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRoute =
  unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/png',
      path: '/export/v1/loop-visualization/dashboard/$dashboardId/png',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const appOrgOrgSettingsTeamsTeamTeamIdRouteRoute =
  appOrgOrgSettingsTeamsTeamTeamIdRouteRouteImport.update({
    id: '/team/$teamId',
    path: '/team/$teamId',
    getParentRoute: () => appOrgOrgSettingsTeamsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsMainRouteRouteImport.update({
    id: '/main',
    path: '/main',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerLiveRouteRoute =
  appOrgOrgLoopLoopIdPlannerLiveRouteRouteImport.update({
    id: '/live',
    path: '/live',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRouteImport.update({
    id: '/logs/',
    path: '/logs/',
    getParentRoute: () =>
      appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute,
  } as any)
const appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRouteImport.update({
    id: '/issues/',
    path: '/issues/',
    getParentRoute: () =>
      appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersUserIdIndexRoute =
  appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport.update({
    id: '/$userId/',
    path: '/$userId/',
    getParentRoute: () => appOrgOrgSettingsUserManagementUsersRouteRoute,
  } as any)
const appOrgOrgSettingsTeamsTeamTeamIdIndexRoute =
  appOrgOrgSettingsTeamsTeamTeamIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsTeamsTeamTeamIdRouteRoute,
  } as any)
const appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute =
  appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRouteImport.update(
    {
      id: '/idea-manager/',
      path: '/idea-manager/',
      getParentRoute: () =>
        appOrgOrgSettingsNotificationsSubscriptionsRouteRoute,
    } as any,
  )
const appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute =
  appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRouteImport.update(
    {
      id: '/workload-scheme/$workloadSchemeId/',
      path: '/workload-scheme/$workloadSchemeId/',
      getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
    } as any,
  )
const appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute =
  appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport.update({
    id: '/holiday-scheme/$holidaySchemeId/',
    path: '/holiday-scheme/$holidaySchemeId/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdStrategyManageIndexRoute =
  appOrgOrgLoopLoopIdStrategyManageIndexRouteImport.update({
    id: '/strategy/manage/',
    path: '/strategy/manage/',
    getParentRoute: () => appOrgOrgLoopLoopIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioTimelineIndexRoute =
  appOrgOrgLoopLoopIdPortfolioTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioTableIndexRoute =
  appOrgOrgLoopLoopIdPortfolioTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRoute =
  appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRouteImport.update({
    id: '/swimlane/',
    path: '/swimlane/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRoute =
  appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRouteImport.update({
    id: '/node-graph/',
    path: '/node-graph/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerLiveIndexRoute =
  appOrgOrgLoopLoopIdPlannerLiveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerLiveRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute =
  appOrgOrgLoopLoopIdDashboardDeliverablesIndexRouteImport.update({
    id: '/deliverables/',
    path: '/deliverables/',
    getParentRoute: () => appOrgOrgLoopLoopIdDashboardRouteRoute,
  } as any)
const appOrgOrgIntakePortalsPortalIdFormIdIndexRoute =
  appOrgOrgIntakePortalsPortalIdFormIdIndexRouteImport.update({
    id: '/$portalId/$formId/',
    path: '/$portalId/$formId/',
    getParentRoute: () => appOrgOrgIntakePortalsRouteRoute,
  } as any)
const appOrgOrgIntakeIdeasViewViewIdIndexRoute =
  appOrgOrgIntakeIdeasViewViewIdIndexRouteImport.update({
    id: '/ideas/view/$viewId/',
    path: '/ideas/view/$viewId/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteImport.update({
    id: '/view/$viewId',
    path: '/view/$viewId',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute =
  appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteImport.update({
    id: '/view/$viewId',
    path: '/view/$viewId',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteImport.update({
    id: '/scenario/$scenarioId',
    path: '/scenario/$scenarioId',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRouteImport.update({
    id: '/swimlane/',
    path: '/swimlane/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRouteImport.update({
    id: '/node-graph/',
    path: '/node-graph/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsMainRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRoute =
  appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRoute =
  appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerLiveRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerLiveTableIndexRoute =
  appOrgOrgLoopLoopIdPlannerLiveTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgLoopLoopIdPlannerLiveRouteRoute,
  } as any)
const appOrgOrgIntakeDemandsViewsViewViewIdIndexRoute =
  appOrgOrgIntakeDemandsViewsViewViewIdIndexRouteImport.update({
    id: '/demands/views/view/$viewId/',
    path: '/demands/views/view/$viewId/',
    getParentRoute: () => appOrgOrgIntakeRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRouteImport.update({
    id: '/swimlane/',
    path: '/swimlane/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRouteImport.update({
    id: '/node-graph/',
    path: '/node-graph/',
    getParentRoute: () => appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRoute =
  appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRoute =
  appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRoute =
  appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRouteImport.update({
    id: '/swimlane/',
    path: '/swimlane/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRoute =
  appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRouteImport.update({
    id: '/node-graph/',
    path: '/node-graph/',
    getParentRoute: () => appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () =>
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () =>
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute,
  } as any)
const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRoute =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () =>
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute,
  } as any)
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute =
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRouteImport.update(
    {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf',
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRouteImport.update(
    {
      id: '/timeline/preview/$visualizationId',
      path: '/timeline/preview/$visualizationId',
      getParentRoute: () =>
        appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
    } as any,
  )
const appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRouteImport.update(
    {
      id: '/swimlane/preview/$visualizationId',
      path: '/swimlane/preview/$visualizationId',
      getParentRoute: () =>
        appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/auth-error': typeof unauthenticatedAuthErrorRoute
  '/idp-login': typeof unauthenticatedIdpLoginRoute
  '/signup': typeof unauthenticatedSignupRoute
  '/terms': typeof unauthenticatedTermsRoute
  '/': typeof appIndexRoute
  '/org/$org': typeof appOrgOrgRouteRouteWithChildren
  '/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/invites/auto-accept': typeof appInvitesAutoAcceptRoute
  '/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/organizations/not-a-member': typeof unauthenticatedOrganizationsNotAMemberRoute
  '/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/invites/': typeof appInvitesIndexRoute
  '/org/': typeof appOrgIndexRoute
  '/profile/': typeof appProfileIndexRoute
  '/link-identity/': typeof unauthenticatedLinkIdentityIndexRoute
  '/login/': typeof unauthenticatedLoginIndexRoute
  '/organization-selector/': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/org/$org/intake': typeof appOrgOrgIntakeRouteRouteWithChildren
  '/org/$org/loop': typeof appOrgOrgLoopRouteRouteWithChildren
  '/org/$org/loop-intelligence': typeof appOrgOrgLoopIntelligenceRouteRouteWithChildren
  '/org/$org/settings': typeof appOrgOrgSettingsRouteRouteWithChildren
  '/integrations/$provider/callback': typeof appIntegrationsProviderCallbackRoute
  '/integrations/github/callback': typeof appIntegrationsGithubCallbackRoute
  '/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/integrations/slack/callback': typeof appIntegrationsSlackCallbackRoute
  '/org-id/$orgId/$': typeof appOrgIdOrgIdSplatRoute
  '/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/org/$org/': typeof appOrgOrgIndexRoute
  '/org/$org/intake/inbox': typeof appOrgOrgIntakeInboxRouteRouteWithChildren
  '/org/$org/intake/portals': typeof appOrgOrgIntakePortalsRouteRouteWithChildren
  '/org/$org/loop/$loopId': typeof appOrgOrgLoopLoopIdRouteRouteWithChildren
  '/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  '/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  '/org/$org/settings/credits': typeof appOrgOrgSettingsCreditsRouteRouteWithChildren
  '/org/$org/settings/currency': typeof appOrgOrgSettingsCurrencyRouteRouteWithChildren
  '/org/$org/settings/domains': typeof appOrgOrgSettingsDomainsRouteRouteWithChildren
  '/org/$org/settings/location': typeof appOrgOrgSettingsLocationRouteRouteWithChildren
  '/org/$org/settings/oauth-clients': typeof appOrgOrgSettingsOauthClientsRouteRouteWithChildren
  '/org/$org/settings/open-positions': typeof appOrgOrgSettingsOpenPositionsRouteRouteWithChildren
  '/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  '/org/$org/settings/people': typeof appOrgOrgSettingsPeopleRouteRouteWithChildren
  '/org/$org/settings/roles': typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  '/org/$org/settings/skills': typeof appOrgOrgSettingsSkillsRouteRouteWithChildren
  '/org/$org/settings/subscriptions': typeof appOrgOrgSettingsSubscriptionsRouteRouteWithChildren
  '/org/$org/settings/teams': typeof appOrgOrgSettingsTeamsRouteRouteWithChildren
  '/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  '/org/$org/settings/work-item-usage': typeof appOrgOrgSettingsWorkItemUsageRouteRouteWithChildren
  '/org/$org/audit/$entityId': typeof appOrgOrgAuditEntityIdRoute
  '/org/$org/idea-management/$': typeof appOrgOrgIdeaManagementSplatRoute
  '/org/$org/intake/custom-fields': typeof appOrgOrgIntakeCustomFieldsRoute
  '/org/$org/intake/overview': typeof appOrgOrgIntakeOverviewRoute
  '/org/$org/intake/priority-frameworks': typeof appOrgOrgIntakePriorityFrameworksRoute
  '/published/v1/swimlane/$linkId': typeof unauthenticatedPublishedV1SwimlaneLinkIdRoute
  '/published/v1/timeline/$linkId': typeof unauthenticatedPublishedV1TimelineLinkIdRoute
  '/org/$org/all-items/': typeof appOrgOrgAllItemsIndexRoute
  '/org/$org/dashboards/': typeof appOrgOrgDashboardsIndexRoute
  '/org/$org/demand/': typeof appOrgOrgDemandIndexRoute
  '/org/$org/idea-management/': typeof appOrgOrgIdeaManagementIndexRoute
  '/org/$org/intake/': typeof appOrgOrgIntakeIndexRoute
  '/org/$org/loop-intelligence/': typeof appOrgOrgLoopIntelligenceIndexRoute
  '/org/$org/notifications/': typeof appOrgOrgNotificationsIndexRoute
  '/org/$org/objectives/': typeof appOrgOrgObjectivesIndexRoute
  '/org/$org/settings/': typeof appOrgOrgSettingsIndexRoute
  '/org/$org/sir-debug/': typeof appOrgOrgSirDebugIndexRoute
  '/org/$org/visualizations/': typeof appOrgOrgVisualizationsIndexRoute
  '/organizations/invites/error/': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/org/$org/loop/$loopId/dashboard': typeof appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren
  '/org/$org/loop/$loopId/planner': typeof appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren
  '/org/$org/loop/$loopId/portfolio': typeof appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren
  '/org/$org/loop/$loopId/teams': typeof appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren
  '/org/$org/loop/$loopId/visualizations': typeof appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren
  '/org/$org/settings/notifications/subscriptions': typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren
  '/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  '/org/$org/settings/work-integrations/$integrationId': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren
  '/org/$org/settings/notifications/slack_app_health': typeof appOrgOrgSettingsNotificationsSlack_app_healthRoute
  '/org/$org/settings/oauth-clients/$id': typeof appOrgOrgSettingsOauthClientsIdRoute
  '/org/$org/settings/open-positions/hired': typeof appOrgOrgSettingsOpenPositionsHiredRoute
  '/org/$org/dashboards/$dashboardId/': typeof appOrgOrgDashboardsDashboardIdIndexRoute
  '/org/$org/intake/customers/': typeof appOrgOrgIntakeCustomersIndexRoute
  '/org/$org/intake/demands/': typeof appOrgOrgIntakeDemandsIndexRoute
  '/org/$org/intake/ideas/': typeof appOrgOrgIntakeIdeasIndexRoute
  '/org/$org/intake/inbox/': typeof appOrgOrgIntakeInboxIndexRoute
  '/org/$org/intake/portals/': typeof appOrgOrgIntakePortalsIndexRoute
  '/org/$org/intake/product-areas/': typeof appOrgOrgIntakeProductAreasIndexRoute
  '/org/$org/loop/$loopId/': typeof appOrgOrgLoopLoopIdIndexRoute
  '/org/$org/settings/accounting-sandbox/': typeof appOrgOrgSettingsAccountingSandboxIndexRoute
  '/org/$org/settings/audit/': typeof appOrgOrgSettingsAuditIndexRoute
  '/org/$org/settings/capacity/': typeof appOrgOrgSettingsCapacityIndexRoute
  '/org/$org/settings/connections/': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/org/$org/settings/credits/': typeof appOrgOrgSettingsCreditsIndexRoute
  '/org/$org/settings/currency/': typeof appOrgOrgSettingsCurrencyIndexRoute
  '/org/$org/settings/custom-fields/': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/org/$org/settings/custom-item-status/': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/org/$org/settings/domains/': typeof appOrgOrgSettingsDomainsIndexRoute
  '/org/$org/settings/effort-estimation/': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/org/$org/settings/item-types/': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/org/$org/settings/location/': typeof appOrgOrgSettingsLocationIndexRoute
  '/org/$org/settings/notifications/': typeof appOrgOrgSettingsNotificationsIndexRoute
  '/org/$org/settings/oauth-clients/': typeof appOrgOrgSettingsOauthClientsIndexRoute
  '/org/$org/settings/open-positions/': typeof appOrgOrgSettingsOpenPositionsIndexRoute
  '/org/$org/settings/organization/': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/org/$org/settings/people/': typeof appOrgOrgSettingsPeopleIndexRoute
  '/org/$org/settings/roles/': typeof appOrgOrgSettingsRolesIndexRoute
  '/org/$org/settings/skills/': typeof appOrgOrgSettingsSkillsIndexRoute
  '/org/$org/settings/subscriptions/': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/org/$org/settings/teams/': typeof appOrgOrgSettingsTeamsIndexRoute
  '/org/$org/settings/user-management/': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/org/$org/settings/work-integrations/': typeof appOrgOrgSettingsWorkIntegrationsIndexRoute
  '/org/$org/settings/work-item-usage/': typeof appOrgOrgSettingsWorkItemUsageIndexRoute
  '/org/$org/loop/$loopId/planner/live': typeof appOrgOrgLoopLoopIdPlannerLiveRouteRouteWithChildren
  '/org/$org/loop/$loopId/visualizations/main': typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren
  '/org/$org/settings/teams/team/$teamId': typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren
  '/export/v1/loop-visualization/dashboard/$dashboardId/png': typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRoute
  '/export/v1/loop-visualization/dashboard/$dashboardId/svg': typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRoute
  '/org/$org/dashboards/generated/$dashboardId/': typeof appOrgOrgDashboardsGeneratedDashboardIdIndexRoute
  '/org/$org/intake/demands/statuses/': typeof appOrgOrgIntakeDemandsStatusesIndexRoute
  '/org/$org/intake/demands/views/': typeof appOrgOrgIntakeDemandsViewsIndexRoute
  '/org/$org/intake/ideas/all/': typeof appOrgOrgIntakeIdeasAllIndexRoute
  '/org/$org/intake/ideas/completed/': typeof appOrgOrgIntakeIdeasCompletedIndexRoute
  '/org/$org/intake/ideas/create/': typeof appOrgOrgIntakeIdeasCreateIndexRoute
  '/org/$org/intake/ideas/view/': typeof appOrgOrgIntakeIdeasViewIndexRoute
  '/org/$org/intake/portals/$portalId/': typeof appOrgOrgIntakePortalsPortalIdIndexRoute
  '/org/$org/intake/portals/create/': typeof appOrgOrgIntakePortalsCreateIndexRoute
  '/org/$org/intake/product-areas/$productAreaId/': typeof appOrgOrgIntakeProductAreasProductAreaIdIndexRoute
  '/org/$org/intake/product-areas/create/': typeof appOrgOrgIntakeProductAreasCreateIndexRoute
  '/org/$org/loop/$loopId/dashboard/': typeof appOrgOrgLoopLoopIdDashboardIndexRoute
  '/org/$org/loop/$loopId/financials/': typeof appOrgOrgLoopLoopIdFinancialsIndexRoute
  '/org/$org/loop/$loopId/integrations/': typeof appOrgOrgLoopLoopIdIntegrationsIndexRoute
  '/org/$org/loop/$loopId/intelligence/': typeof appOrgOrgLoopLoopIdIntelligenceIndexRoute
  '/org/$org/loop/$loopId/loop-intelligence/': typeof appOrgOrgLoopLoopIdLoopIntelligenceIndexRoute
  '/org/$org/loop/$loopId/overview/': typeof appOrgOrgLoopLoopIdOverviewIndexRoute
  '/org/$org/loop/$loopId/planner/': typeof appOrgOrgLoopLoopIdPlannerIndexRoute
  '/org/$org/loop/$loopId/portfolio/': typeof appOrgOrgLoopLoopIdPortfolioIndexRoute
  '/org/$org/loop/$loopId/strategy/': typeof appOrgOrgLoopLoopIdStrategyIndexRoute
  '/org/$org/loop/$loopId/teams/': typeof appOrgOrgLoopLoopIdTeamsIndexRoute
  '/org/$org/loop/$loopId/visualizations/': typeof appOrgOrgLoopLoopIdVisualizationsIndexRoute
  '/org/$org/settings/capacity/holiday-scheme/': typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRoute
  '/org/$org/settings/capacity/orphaned-data/': typeof appOrgOrgSettingsCapacityOrphanedDataIndexRoute
  '/org/$org/settings/capacity/workload-scheme/': typeof appOrgOrgSettingsCapacityWorkloadSchemeIndexRoute
  '/org/$org/settings/notifications/subscriptions/': typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRoute
  '/org/$org/settings/user-management/invites/': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/org/$org/settings/user-management/users/': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren
  '/org/$org/loop/$loopId/portfolio/view/$viewId': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteWithChildren
  '/org/$org/loop/$loopId/visualizations/view/$viewId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren
  '/org/$org/intake/ideas/view/$viewId/': typeof appOrgOrgIntakeIdeasViewViewIdIndexRoute
  '/org/$org/intake/portals/$portalId/$formId/': typeof appOrgOrgIntakePortalsPortalIdFormIdIndexRoute
  '/org/$org/loop/$loopId/dashboard/deliverables/': typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute
  '/org/$org/loop/$loopId/planner/live/': typeof appOrgOrgLoopLoopIdPlannerLiveIndexRoute
  '/org/$org/loop/$loopId/portfolio/node-graph/': typeof appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRoute
  '/org/$org/loop/$loopId/portfolio/swimlane/': typeof appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRoute
  '/org/$org/loop/$loopId/portfolio/table/': typeof appOrgOrgLoopLoopIdPortfolioTableIndexRoute
  '/org/$org/loop/$loopId/portfolio/timeline/': typeof appOrgOrgLoopLoopIdPortfolioTimelineIndexRoute
  '/org/$org/loop/$loopId/strategy/manage/': typeof appOrgOrgLoopLoopIdStrategyManageIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/': typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRoute
  '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/': typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute
  '/org/$org/settings/notifications/subscriptions/idea-manager/': typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute
  '/org/$org/settings/teams/team/$teamId/': typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRoute
  '/org/$org/settings/user-management/users/$userId/': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/issues/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/logs/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute
  '/org/$org/intake/demands/views/view/$viewId/': typeof appOrgOrgIntakeDemandsViewsViewViewIdIndexRoute
  '/org/$org/loop/$loopId/planner/live/table/': typeof appOrgOrgLoopLoopIdPlannerLiveTableIndexRoute
  '/org/$org/loop/$loopId/planner/live/timeline/': typeof appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/node-graph/': typeof appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/swimlane/': typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/table/': typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/timeline/': typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/table/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/table/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute
}
export interface FileRoutesByTo {
  '/auth-error': typeof unauthenticatedAuthErrorRoute
  '/idp-login': typeof unauthenticatedIdpLoginRoute
  '/signup': typeof unauthenticatedSignupRoute
  '/terms': typeof unauthenticatedTermsRoute
  '/': typeof appIndexRoute
  '/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/invites/auto-accept': typeof appInvitesAutoAcceptRoute
  '/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/organizations/not-a-member': typeof unauthenticatedOrganizationsNotAMemberRoute
  '/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/invites': typeof appInvitesIndexRoute
  '/org': typeof appOrgIndexRoute
  '/profile': typeof appProfileIndexRoute
  '/link-identity': typeof unauthenticatedLinkIdentityIndexRoute
  '/login': typeof unauthenticatedLoginIndexRoute
  '/organization-selector': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/org/$org/loop': typeof appOrgOrgLoopRouteRouteWithChildren
  '/integrations/$provider/callback': typeof appIntegrationsProviderCallbackRoute
  '/integrations/github/callback': typeof appIntegrationsGithubCallbackRoute
  '/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/integrations/slack/callback': typeof appIntegrationsSlackCallbackRoute
  '/org-id/$orgId/$': typeof appOrgIdOrgIdSplatRoute
  '/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/org/$org': typeof appOrgOrgIndexRoute
  '/org/$org/audit/$entityId': typeof appOrgOrgAuditEntityIdRoute
  '/org/$org/idea-management/$': typeof appOrgOrgIdeaManagementSplatRoute
  '/org/$org/intake/custom-fields': typeof appOrgOrgIntakeCustomFieldsRoute
  '/org/$org/intake/overview': typeof appOrgOrgIntakeOverviewRoute
  '/org/$org/intake/priority-frameworks': typeof appOrgOrgIntakePriorityFrameworksRoute
  '/published/v1/swimlane/$linkId': typeof unauthenticatedPublishedV1SwimlaneLinkIdRoute
  '/published/v1/timeline/$linkId': typeof unauthenticatedPublishedV1TimelineLinkIdRoute
  '/org/$org/all-items': typeof appOrgOrgAllItemsIndexRoute
  '/org/$org/dashboards': typeof appOrgOrgDashboardsIndexRoute
  '/org/$org/demand': typeof appOrgOrgDemandIndexRoute
  '/org/$org/idea-management': typeof appOrgOrgIdeaManagementIndexRoute
  '/org/$org/intake': typeof appOrgOrgIntakeIndexRoute
  '/org/$org/loop-intelligence': typeof appOrgOrgLoopIntelligenceIndexRoute
  '/org/$org/notifications': typeof appOrgOrgNotificationsIndexRoute
  '/org/$org/objectives': typeof appOrgOrgObjectivesIndexRoute
  '/org/$org/settings': typeof appOrgOrgSettingsIndexRoute
  '/org/$org/sir-debug': typeof appOrgOrgSirDebugIndexRoute
  '/org/$org/visualizations': typeof appOrgOrgVisualizationsIndexRoute
  '/organizations/invites/error': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/org/$org/settings/notifications/slack_app_health': typeof appOrgOrgSettingsNotificationsSlack_app_healthRoute
  '/org/$org/settings/oauth-clients/$id': typeof appOrgOrgSettingsOauthClientsIdRoute
  '/org/$org/settings/open-positions/hired': typeof appOrgOrgSettingsOpenPositionsHiredRoute
  '/org/$org/dashboards/$dashboardId': typeof appOrgOrgDashboardsDashboardIdIndexRoute
  '/org/$org/intake/customers': typeof appOrgOrgIntakeCustomersIndexRoute
  '/org/$org/intake/demands': typeof appOrgOrgIntakeDemandsIndexRoute
  '/org/$org/intake/ideas': typeof appOrgOrgIntakeIdeasIndexRoute
  '/org/$org/intake/inbox': typeof appOrgOrgIntakeInboxIndexRoute
  '/org/$org/intake/portals': typeof appOrgOrgIntakePortalsIndexRoute
  '/org/$org/intake/product-areas': typeof appOrgOrgIntakeProductAreasIndexRoute
  '/org/$org/loop/$loopId': typeof appOrgOrgLoopLoopIdIndexRoute
  '/org/$org/settings/accounting-sandbox': typeof appOrgOrgSettingsAccountingSandboxIndexRoute
  '/org/$org/settings/audit': typeof appOrgOrgSettingsAuditIndexRoute
  '/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityIndexRoute
  '/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/org/$org/settings/credits': typeof appOrgOrgSettingsCreditsIndexRoute
  '/org/$org/settings/currency': typeof appOrgOrgSettingsCurrencyIndexRoute
  '/org/$org/settings/custom-fields': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/org/$org/settings/custom-item-status': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/org/$org/settings/domains': typeof appOrgOrgSettingsDomainsIndexRoute
  '/org/$org/settings/effort-estimation': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/org/$org/settings/item-types': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/org/$org/settings/location': typeof appOrgOrgSettingsLocationIndexRoute
  '/org/$org/settings/notifications': typeof appOrgOrgSettingsNotificationsIndexRoute
  '/org/$org/settings/oauth-clients': typeof appOrgOrgSettingsOauthClientsIndexRoute
  '/org/$org/settings/open-positions': typeof appOrgOrgSettingsOpenPositionsIndexRoute
  '/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/org/$org/settings/people': typeof appOrgOrgSettingsPeopleIndexRoute
  '/org/$org/settings/roles': typeof appOrgOrgSettingsRolesIndexRoute
  '/org/$org/settings/skills': typeof appOrgOrgSettingsSkillsIndexRoute
  '/org/$org/settings/subscriptions': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/org/$org/settings/teams': typeof appOrgOrgSettingsTeamsIndexRoute
  '/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/org/$org/settings/work-integrations': typeof appOrgOrgSettingsWorkIntegrationsIndexRoute
  '/org/$org/settings/work-item-usage': typeof appOrgOrgSettingsWorkItemUsageIndexRoute
  '/export/v1/loop-visualization/dashboard/$dashboardId/png': typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRoute
  '/export/v1/loop-visualization/dashboard/$dashboardId/svg': typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRoute
  '/org/$org/dashboards/generated/$dashboardId': typeof appOrgOrgDashboardsGeneratedDashboardIdIndexRoute
  '/org/$org/intake/demands/statuses': typeof appOrgOrgIntakeDemandsStatusesIndexRoute
  '/org/$org/intake/demands/views': typeof appOrgOrgIntakeDemandsViewsIndexRoute
  '/org/$org/intake/ideas/all': typeof appOrgOrgIntakeIdeasAllIndexRoute
  '/org/$org/intake/ideas/completed': typeof appOrgOrgIntakeIdeasCompletedIndexRoute
  '/org/$org/intake/ideas/create': typeof appOrgOrgIntakeIdeasCreateIndexRoute
  '/org/$org/intake/ideas/view': typeof appOrgOrgIntakeIdeasViewIndexRoute
  '/org/$org/intake/portals/$portalId': typeof appOrgOrgIntakePortalsPortalIdIndexRoute
  '/org/$org/intake/portals/create': typeof appOrgOrgIntakePortalsCreateIndexRoute
  '/org/$org/intake/product-areas/$productAreaId': typeof appOrgOrgIntakeProductAreasProductAreaIdIndexRoute
  '/org/$org/intake/product-areas/create': typeof appOrgOrgIntakeProductAreasCreateIndexRoute
  '/org/$org/loop/$loopId/dashboard': typeof appOrgOrgLoopLoopIdDashboardIndexRoute
  '/org/$org/loop/$loopId/financials': typeof appOrgOrgLoopLoopIdFinancialsIndexRoute
  '/org/$org/loop/$loopId/integrations': typeof appOrgOrgLoopLoopIdIntegrationsIndexRoute
  '/org/$org/loop/$loopId/intelligence': typeof appOrgOrgLoopLoopIdIntelligenceIndexRoute
  '/org/$org/loop/$loopId/loop-intelligence': typeof appOrgOrgLoopLoopIdLoopIntelligenceIndexRoute
  '/org/$org/loop/$loopId/overview': typeof appOrgOrgLoopLoopIdOverviewIndexRoute
  '/org/$org/loop/$loopId/planner': typeof appOrgOrgLoopLoopIdPlannerIndexRoute
  '/org/$org/loop/$loopId/portfolio': typeof appOrgOrgLoopLoopIdPortfolioIndexRoute
  '/org/$org/loop/$loopId/strategy': typeof appOrgOrgLoopLoopIdStrategyIndexRoute
  '/org/$org/loop/$loopId/teams': typeof appOrgOrgLoopLoopIdTeamsIndexRoute
  '/org/$org/loop/$loopId/visualizations': typeof appOrgOrgLoopLoopIdVisualizationsIndexRoute
  '/org/$org/settings/capacity/holiday-scheme': typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRoute
  '/org/$org/settings/capacity/orphaned-data': typeof appOrgOrgSettingsCapacityOrphanedDataIndexRoute
  '/org/$org/settings/capacity/workload-scheme': typeof appOrgOrgSettingsCapacityWorkloadSchemeIndexRoute
  '/org/$org/settings/notifications/subscriptions': typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRoute
  '/org/$org/settings/user-management/invites': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/org/$org/settings/work-integrations/$integrationId': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute
  '/org/$org/intake/ideas/view/$viewId': typeof appOrgOrgIntakeIdeasViewViewIdIndexRoute
  '/org/$org/intake/portals/$portalId/$formId': typeof appOrgOrgIntakePortalsPortalIdFormIdIndexRoute
  '/org/$org/loop/$loopId/dashboard/deliverables': typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute
  '/org/$org/loop/$loopId/planner/live': typeof appOrgOrgLoopLoopIdPlannerLiveIndexRoute
  '/org/$org/loop/$loopId/portfolio/node-graph': typeof appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRoute
  '/org/$org/loop/$loopId/portfolio/swimlane': typeof appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRoute
  '/org/$org/loop/$loopId/portfolio/table': typeof appOrgOrgLoopLoopIdPortfolioTableIndexRoute
  '/org/$org/loop/$loopId/portfolio/timeline': typeof appOrgOrgLoopLoopIdPortfolioTimelineIndexRoute
  '/org/$org/loop/$loopId/strategy/manage': typeof appOrgOrgLoopLoopIdStrategyManageIndexRoute
  '/org/$org/loop/$loopId/visualizations/main': typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRoute
  '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId': typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute
  '/org/$org/settings/notifications/subscriptions/idea-manager': typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute
  '/org/$org/settings/teams/team/$teamId': typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRoute
  '/org/$org/settings/user-management/users/$userId': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/issues': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute
  '/org/$org/settings/work-integrations/$integrationId/logs': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute
  '/org/$org/intake/demands/views/view/$viewId': typeof appOrgOrgIntakeDemandsViewsViewViewIdIndexRoute
  '/org/$org/loop/$loopId/planner/live/table': typeof appOrgOrgLoopLoopIdPlannerLiveTableIndexRoute
  '/org/$org/loop/$loopId/planner/live/timeline': typeof appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/node-graph': typeof appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/swimlane': typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/table': typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute
  '/org/$org/loop/$loopId/visualizations/main/timeline': typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute
  '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute
  '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/table': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRoute
  '/org/$org/loop/$loopId/portfolio/view/$viewId/timeline': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/table': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute
  '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(app)': typeof appRouteRouteWithChildren
  '/(unauthenticated)/auth-error': typeof unauthenticatedAuthErrorRoute
  '/(unauthenticated)/idp-login': typeof unauthenticatedIdpLoginRoute
  '/(unauthenticated)/signup': typeof unauthenticatedSignupRoute
  '/(unauthenticated)/terms': typeof unauthenticatedTermsRoute
  '/(app)/': typeof appIndexRoute
  '/(app)/org/$org': typeof appOrgOrgRouteRouteWithChildren
  '/(unauthenticated)/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/(app)/invites/auto-accept': typeof appInvitesAutoAcceptRoute
  '/(unauthenticated)/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/(unauthenticated)/organizations/not-a-member': typeof unauthenticatedOrganizationsNotAMemberRoute
  '/(unauthenticated)/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/(app)/invites/': typeof appInvitesIndexRoute
  '/(app)/org/': typeof appOrgIndexRoute
  '/(app)/profile/': typeof appProfileIndexRoute
  '/(unauthenticated)/link-identity/': typeof unauthenticatedLinkIdentityIndexRoute
  '/(unauthenticated)/login/': typeof unauthenticatedLoginIndexRoute
  '/(unauthenticated)/organization-selector/': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/(app)/org/$org/intake': typeof appOrgOrgIntakeRouteRouteWithChildren
  '/(app)/org/$org/loop': typeof appOrgOrgLoopRouteRouteWithChildren
  '/(app)/org/$org/loop-intelligence': typeof appOrgOrgLoopIntelligenceRouteRouteWithChildren
  '/(app)/org/$org/settings': typeof appOrgOrgSettingsRouteRouteWithChildren
  '/(app)/integrations/$provider/callback': typeof appIntegrationsProviderCallbackRoute
  '/(app)/integrations/github/callback': typeof appIntegrationsGithubCallbackRoute
  '/(app)/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/(app)/integrations/slack/callback': typeof appIntegrationsSlackCallbackRoute
  '/(app)/org-id/$orgId/$': typeof appOrgIdOrgIdSplatRoute
  '/(unauthenticated)/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/(app)/org/$org/': typeof appOrgOrgIndexRoute
  '/(app)/org/$org/intake/inbox': typeof appOrgOrgIntakeInboxRouteRouteWithChildren
  '/(app)/org/$org/intake/portals': typeof appOrgOrgIntakePortalsRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId': typeof appOrgOrgLoopLoopIdRouteRouteWithChildren
  '/(app)/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  '/(app)/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  '/(app)/org/$org/settings/credits': typeof appOrgOrgSettingsCreditsRouteRouteWithChildren
  '/(app)/org/$org/settings/currency': typeof appOrgOrgSettingsCurrencyRouteRouteWithChildren
  '/(app)/org/$org/settings/domains': typeof appOrgOrgSettingsDomainsRouteRouteWithChildren
  '/(app)/org/$org/settings/location': typeof appOrgOrgSettingsLocationRouteRouteWithChildren
  '/(app)/org/$org/settings/oauth-clients': typeof appOrgOrgSettingsOauthClientsRouteRouteWithChildren
  '/(app)/org/$org/settings/open-positions': typeof appOrgOrgSettingsOpenPositionsRouteRouteWithChildren
  '/(app)/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  '/(app)/org/$org/settings/people': typeof appOrgOrgSettingsPeopleRouteRouteWithChildren
  '/(app)/org/$org/settings/roles': typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  '/(app)/org/$org/settings/skills': typeof appOrgOrgSettingsSkillsRouteRouteWithChildren
  '/(app)/org/$org/settings/subscriptions': typeof appOrgOrgSettingsSubscriptionsRouteRouteWithChildren
  '/(app)/org/$org/settings/teams': typeof appOrgOrgSettingsTeamsRouteRouteWithChildren
  '/(app)/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  '/(app)/org/$org/settings/work-item-usage': typeof appOrgOrgSettingsWorkItemUsageRouteRouteWithChildren
  '/(app)/org/$org/audit/$entityId': typeof appOrgOrgAuditEntityIdRoute
  '/(app)/org/$org/idea-management/$': typeof appOrgOrgIdeaManagementSplatRoute
  '/(app)/org/$org/intake/custom-fields': typeof appOrgOrgIntakeCustomFieldsRoute
  '/(app)/org/$org/intake/overview': typeof appOrgOrgIntakeOverviewRoute
  '/(app)/org/$org/intake/priority-frameworks': typeof appOrgOrgIntakePriorityFrameworksRoute
  '/(unauthenticated)/published/v1/swimlane/$linkId': typeof unauthenticatedPublishedV1SwimlaneLinkIdRoute
  '/(unauthenticated)/published/v1/timeline/$linkId': typeof unauthenticatedPublishedV1TimelineLinkIdRoute
  '/(app)/org/$org/all-items/': typeof appOrgOrgAllItemsIndexRoute
  '/(app)/org/$org/dashboards/': typeof appOrgOrgDashboardsIndexRoute
  '/(app)/org/$org/demand/': typeof appOrgOrgDemandIndexRoute
  '/(app)/org/$org/idea-management/': typeof appOrgOrgIdeaManagementIndexRoute
  '/(app)/org/$org/intake/': typeof appOrgOrgIntakeIndexRoute
  '/(app)/org/$org/loop-intelligence/': typeof appOrgOrgLoopIntelligenceIndexRoute
  '/(app)/org/$org/notifications/': typeof appOrgOrgNotificationsIndexRoute
  '/(app)/org/$org/objectives/': typeof appOrgOrgObjectivesIndexRoute
  '/(app)/org/$org/settings/': typeof appOrgOrgSettingsIndexRoute
  '/(app)/org/$org/sir-debug/': typeof appOrgOrgSirDebugIndexRoute
  '/(app)/org/$org/visualizations/': typeof appOrgOrgVisualizationsIndexRoute
  '/(unauthenticated)/organizations/invites/error/': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/(app)/org/$org/loop/$loopId/dashboard': typeof appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/planner': typeof appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/portfolio': typeof appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/teams': typeof appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/visualizations': typeof appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren
  '/(app)/org/$org/settings/notifications/subscriptions': typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren
  '/(app)/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  '/(app)/org/$org/settings/work-integrations/$integrationId': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren
  '/(app)/org/$org/settings/notifications/slack_app_health': typeof appOrgOrgSettingsNotificationsSlack_app_healthRoute
  '/(app)/org/$org/settings/oauth-clients/$id': typeof appOrgOrgSettingsOauthClientsIdRoute
  '/(app)/org/$org/settings/open-positions/hired': typeof appOrgOrgSettingsOpenPositionsHiredRoute
  '/(app)/org/$org/dashboards/$dashboardId/': typeof appOrgOrgDashboardsDashboardIdIndexRoute
  '/(app)/org/$org/intake/customers/': typeof appOrgOrgIntakeCustomersIndexRoute
  '/(app)/org/$org/intake/demands/': typeof appOrgOrgIntakeDemandsIndexRoute
  '/(app)/org/$org/intake/ideas/': typeof appOrgOrgIntakeIdeasIndexRoute
  '/(app)/org/$org/intake/inbox/': typeof appOrgOrgIntakeInboxIndexRoute
  '/(app)/org/$org/intake/portals/': typeof appOrgOrgIntakePortalsIndexRoute
  '/(app)/org/$org/intake/product-areas/': typeof appOrgOrgIntakeProductAreasIndexRoute
  '/(app)/org/$org/loop/$loopId/': typeof appOrgOrgLoopLoopIdIndexRoute
  '/(app)/org/$org/settings/accounting-sandbox/': typeof appOrgOrgSettingsAccountingSandboxIndexRoute
  '/(app)/org/$org/settings/audit/': typeof appOrgOrgSettingsAuditIndexRoute
  '/(app)/org/$org/settings/capacity/': typeof appOrgOrgSettingsCapacityIndexRoute
  '/(app)/org/$org/settings/connections/': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/(app)/org/$org/settings/credits/': typeof appOrgOrgSettingsCreditsIndexRoute
  '/(app)/org/$org/settings/currency/': typeof appOrgOrgSettingsCurrencyIndexRoute
  '/(app)/org/$org/settings/custom-fields/': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/(app)/org/$org/settings/custom-item-status/': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/(app)/org/$org/settings/domains/': typeof appOrgOrgSettingsDomainsIndexRoute
  '/(app)/org/$org/settings/effort-estimation/': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/(app)/org/$org/settings/item-types/': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/(app)/org/$org/settings/location/': typeof appOrgOrgSettingsLocationIndexRoute
  '/(app)/org/$org/settings/notifications/': typeof appOrgOrgSettingsNotificationsIndexRoute
  '/(app)/org/$org/settings/oauth-clients/': typeof appOrgOrgSettingsOauthClientsIndexRoute
  '/(app)/org/$org/settings/open-positions/': typeof appOrgOrgSettingsOpenPositionsIndexRoute
  '/(app)/org/$org/settings/organization/': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/(app)/org/$org/settings/people/': typeof appOrgOrgSettingsPeopleIndexRoute
  '/(app)/org/$org/settings/roles/': typeof appOrgOrgSettingsRolesIndexRoute
  '/(app)/org/$org/settings/skills/': typeof appOrgOrgSettingsSkillsIndexRoute
  '/(app)/org/$org/settings/subscriptions/': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/(app)/org/$org/settings/teams/': typeof appOrgOrgSettingsTeamsIndexRoute
  '/(app)/org/$org/settings/user-management/': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/(app)/org/$org/settings/work-integrations/': typeof appOrgOrgSettingsWorkIntegrationsIndexRoute
  '/(app)/org/$org/settings/work-item-usage/': typeof appOrgOrgSettingsWorkItemUsageIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/live': typeof appOrgOrgLoopLoopIdPlannerLiveRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/visualizations/main': typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren
  '/(app)/org/$org/settings/teams/team/$teamId': typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren
  '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/png': typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/svg': typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRoute
  '/(app)/org/$org/dashboards/generated/$dashboardId/': typeof appOrgOrgDashboardsGeneratedDashboardIdIndexRoute
  '/(app)/org/$org/intake/demands/statuses/': typeof appOrgOrgIntakeDemandsStatusesIndexRoute
  '/(app)/org/$org/intake/demands/views/': typeof appOrgOrgIntakeDemandsViewsIndexRoute
  '/(app)/org/$org/intake/ideas/all/': typeof appOrgOrgIntakeIdeasAllIndexRoute
  '/(app)/org/$org/intake/ideas/completed/': typeof appOrgOrgIntakeIdeasCompletedIndexRoute
  '/(app)/org/$org/intake/ideas/create/': typeof appOrgOrgIntakeIdeasCreateIndexRoute
  '/(app)/org/$org/intake/ideas/view/': typeof appOrgOrgIntakeIdeasViewIndexRoute
  '/(app)/org/$org/intake/portals/$portalId/': typeof appOrgOrgIntakePortalsPortalIdIndexRoute
  '/(app)/org/$org/intake/portals/create/': typeof appOrgOrgIntakePortalsCreateIndexRoute
  '/(app)/org/$org/intake/product-areas/$productAreaId/': typeof appOrgOrgIntakeProductAreasProductAreaIdIndexRoute
  '/(app)/org/$org/intake/product-areas/create/': typeof appOrgOrgIntakeProductAreasCreateIndexRoute
  '/(app)/org/$org/loop/$loopId/dashboard/': typeof appOrgOrgLoopLoopIdDashboardIndexRoute
  '/(app)/org/$org/loop/$loopId/financials/': typeof appOrgOrgLoopLoopIdFinancialsIndexRoute
  '/(app)/org/$org/loop/$loopId/integrations/': typeof appOrgOrgLoopLoopIdIntegrationsIndexRoute
  '/(app)/org/$org/loop/$loopId/intelligence/': typeof appOrgOrgLoopLoopIdIntelligenceIndexRoute
  '/(app)/org/$org/loop/$loopId/loop-intelligence/': typeof appOrgOrgLoopLoopIdLoopIntelligenceIndexRoute
  '/(app)/org/$org/loop/$loopId/overview/': typeof appOrgOrgLoopLoopIdOverviewIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/': typeof appOrgOrgLoopLoopIdPlannerIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/': typeof appOrgOrgLoopLoopIdPortfolioIndexRoute
  '/(app)/org/$org/loop/$loopId/strategy/': typeof appOrgOrgLoopLoopIdStrategyIndexRoute
  '/(app)/org/$org/loop/$loopId/teams/': typeof appOrgOrgLoopLoopIdTeamsIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/': typeof appOrgOrgLoopLoopIdVisualizationsIndexRoute
  '/(app)/org/$org/settings/capacity/holiday-scheme/': typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRoute
  '/(app)/org/$org/settings/capacity/orphaned-data/': typeof appOrgOrgSettingsCapacityOrphanedDataIndexRoute
  '/(app)/org/$org/settings/capacity/workload-scheme/': typeof appOrgOrgSettingsCapacityWorkloadSchemeIndexRoute
  '/(app)/org/$org/settings/notifications/subscriptions/': typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRoute
  '/(app)/org/$org/settings/user-management/invites/': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/(app)/org/$org/settings/user-management/users/': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/(app)/org/$org/settings/work-integrations/$integrationId/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteWithChildren
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren
  '/(app)/org/$org/intake/ideas/view/$viewId/': typeof appOrgOrgIntakeIdeasViewViewIdIndexRoute
  '/(app)/org/$org/intake/portals/$portalId/$formId/': typeof appOrgOrgIntakePortalsPortalIdFormIdIndexRoute
  '/(app)/org/$org/loop/$loopId/dashboard/deliverables/': typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/live/': typeof appOrgOrgLoopLoopIdPlannerLiveIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/node-graph/': typeof appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/swimlane/': typeof appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/table/': typeof appOrgOrgLoopLoopIdPortfolioTableIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/timeline/': typeof appOrgOrgLoopLoopIdPortfolioTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/strategy/manage/': typeof appOrgOrgLoopLoopIdStrategyManageIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/': typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRoute
  '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/': typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute
  '/(app)/org/$org/settings/notifications/subscriptions/idea-manager/': typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute
  '/(app)/org/$org/settings/teams/team/$teamId/': typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRoute
  '/(app)/org/$org/settings/user-management/users/$userId/': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/(app)/org/$org/settings/work-integrations/$integrationId/issues/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute
  '/(app)/org/$org/settings/work-integrations/$integrationId/logs/': typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute
  '/(app)/org/$org/intake/demands/views/view/$viewId/': typeof appOrgOrgIntakeDemandsViewsViewViewIdIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/live/table/': typeof appOrgOrgLoopLoopIdPlannerLiveTableIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/live/timeline/': typeof appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/node-graph/': typeof appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/': typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/table/': typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/main/timeline/': typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute
  '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg': typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute
  '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/': typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/table/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRoute
  '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/': typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute
  '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId': typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth-error'
    | '/idp-login'
    | '/signup'
    | '/terms'
    | '/'
    | '/org/$org'
    | '/organizations/invites'
    | '/invites/auto-accept'
    | '/link-identity/callback'
    | '/organizations/not-a-member'
    | '/organizations/start'
    | '/invites/'
    | '/org/'
    | '/profile/'
    | '/link-identity/'
    | '/login/'
    | '/organization-selector/'
    | '/org/$org/intake'
    | '/org/$org/loop'
    | '/org/$org/loop-intelligence'
    | '/org/$org/settings'
    | '/integrations/$provider/callback'
    | '/integrations/github/callback'
    | '/integrations/jira/callback'
    | '/integrations/slack/callback'
    | '/org-id/$orgId/$'
    | '/organizations/invites/accept'
    | '/org/$org/'
    | '/org/$org/intake/inbox'
    | '/org/$org/intake/portals'
    | '/org/$org/loop/$loopId'
    | '/org/$org/settings/capacity'
    | '/org/$org/settings/connections'
    | '/org/$org/settings/credits'
    | '/org/$org/settings/currency'
    | '/org/$org/settings/domains'
    | '/org/$org/settings/location'
    | '/org/$org/settings/oauth-clients'
    | '/org/$org/settings/open-positions'
    | '/org/$org/settings/organization'
    | '/org/$org/settings/people'
    | '/org/$org/settings/roles'
    | '/org/$org/settings/skills'
    | '/org/$org/settings/subscriptions'
    | '/org/$org/settings/teams'
    | '/org/$org/settings/user-management'
    | '/org/$org/settings/work-item-usage'
    | '/org/$org/audit/$entityId'
    | '/org/$org/idea-management/$'
    | '/org/$org/intake/custom-fields'
    | '/org/$org/intake/overview'
    | '/org/$org/intake/priority-frameworks'
    | '/published/v1/swimlane/$linkId'
    | '/published/v1/timeline/$linkId'
    | '/org/$org/all-items/'
    | '/org/$org/dashboards/'
    | '/org/$org/demand/'
    | '/org/$org/idea-management/'
    | '/org/$org/intake/'
    | '/org/$org/loop-intelligence/'
    | '/org/$org/notifications/'
    | '/org/$org/objectives/'
    | '/org/$org/settings/'
    | '/org/$org/sir-debug/'
    | '/org/$org/visualizations/'
    | '/organizations/invites/error/'
    | '/org/$org/loop/$loopId/dashboard'
    | '/org/$org/loop/$loopId/planner'
    | '/org/$org/loop/$loopId/portfolio'
    | '/org/$org/loop/$loopId/teams'
    | '/org/$org/loop/$loopId/visualizations'
    | '/org/$org/settings/notifications/subscriptions'
    | '/org/$org/settings/user-management/users'
    | '/org/$org/settings/work-integrations/$integrationId'
    | '/org/$org/settings/notifications/slack_app_health'
    | '/org/$org/settings/oauth-clients/$id'
    | '/org/$org/settings/open-positions/hired'
    | '/org/$org/dashboards/$dashboardId/'
    | '/org/$org/intake/customers/'
    | '/org/$org/intake/demands/'
    | '/org/$org/intake/ideas/'
    | '/org/$org/intake/inbox/'
    | '/org/$org/intake/portals/'
    | '/org/$org/intake/product-areas/'
    | '/org/$org/loop/$loopId/'
    | '/org/$org/settings/accounting-sandbox/'
    | '/org/$org/settings/audit/'
    | '/org/$org/settings/capacity/'
    | '/org/$org/settings/connections/'
    | '/org/$org/settings/credits/'
    | '/org/$org/settings/currency/'
    | '/org/$org/settings/custom-fields/'
    | '/org/$org/settings/custom-item-status/'
    | '/org/$org/settings/domains/'
    | '/org/$org/settings/effort-estimation/'
    | '/org/$org/settings/item-types/'
    | '/org/$org/settings/location/'
    | '/org/$org/settings/notifications/'
    | '/org/$org/settings/oauth-clients/'
    | '/org/$org/settings/open-positions/'
    | '/org/$org/settings/organization/'
    | '/org/$org/settings/people/'
    | '/org/$org/settings/roles/'
    | '/org/$org/settings/skills/'
    | '/org/$org/settings/subscriptions/'
    | '/org/$org/settings/teams/'
    | '/org/$org/settings/user-management/'
    | '/org/$org/settings/work-integrations/'
    | '/org/$org/settings/work-item-usage/'
    | '/org/$org/loop/$loopId/planner/live'
    | '/org/$org/loop/$loopId/visualizations/main'
    | '/org/$org/settings/teams/team/$teamId'
    | '/export/v1/loop-visualization/dashboard/$dashboardId/png'
    | '/export/v1/loop-visualization/dashboard/$dashboardId/svg'
    | '/org/$org/dashboards/generated/$dashboardId/'
    | '/org/$org/intake/demands/statuses/'
    | '/org/$org/intake/demands/views/'
    | '/org/$org/intake/ideas/all/'
    | '/org/$org/intake/ideas/completed/'
    | '/org/$org/intake/ideas/create/'
    | '/org/$org/intake/ideas/view/'
    | '/org/$org/intake/portals/$portalId/'
    | '/org/$org/intake/portals/create/'
    | '/org/$org/intake/product-areas/$productAreaId/'
    | '/org/$org/intake/product-areas/create/'
    | '/org/$org/loop/$loopId/dashboard/'
    | '/org/$org/loop/$loopId/financials/'
    | '/org/$org/loop/$loopId/integrations/'
    | '/org/$org/loop/$loopId/intelligence/'
    | '/org/$org/loop/$loopId/loop-intelligence/'
    | '/org/$org/loop/$loopId/overview/'
    | '/org/$org/loop/$loopId/planner/'
    | '/org/$org/loop/$loopId/portfolio/'
    | '/org/$org/loop/$loopId/strategy/'
    | '/org/$org/loop/$loopId/teams/'
    | '/org/$org/loop/$loopId/visualizations/'
    | '/org/$org/settings/capacity/holiday-scheme/'
    | '/org/$org/settings/capacity/orphaned-data/'
    | '/org/$org/settings/capacity/workload-scheme/'
    | '/org/$org/settings/notifications/subscriptions/'
    | '/org/$org/settings/user-management/invites/'
    | '/org/$org/settings/user-management/users/'
    | '/org/$org/settings/work-integrations/$integrationId/'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId'
    | '/org/$org/intake/ideas/view/$viewId/'
    | '/org/$org/intake/portals/$portalId/$formId/'
    | '/org/$org/loop/$loopId/dashboard/deliverables/'
    | '/org/$org/loop/$loopId/planner/live/'
    | '/org/$org/loop/$loopId/portfolio/node-graph/'
    | '/org/$org/loop/$loopId/portfolio/swimlane/'
    | '/org/$org/loop/$loopId/portfolio/table/'
    | '/org/$org/loop/$loopId/portfolio/timeline/'
    | '/org/$org/loop/$loopId/strategy/manage/'
    | '/org/$org/loop/$loopId/visualizations/main/'
    | '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
    | '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/'
    | '/org/$org/settings/notifications/subscriptions/idea-manager/'
    | '/org/$org/settings/teams/team/$teamId/'
    | '/org/$org/settings/user-management/users/$userId/'
    | '/org/$org/settings/work-integrations/$integrationId/issues/'
    | '/org/$org/settings/work-integrations/$integrationId/logs/'
    | '/org/$org/intake/demands/views/view/$viewId/'
    | '/org/$org/loop/$loopId/planner/live/table/'
    | '/org/$org/loop/$loopId/planner/live/timeline/'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/'
    | '/org/$org/loop/$loopId/visualizations/main/node-graph/'
    | '/org/$org/loop/$loopId/visualizations/main/swimlane/'
    | '/org/$org/loop/$loopId/visualizations/main/table/'
    | '/org/$org/loop/$loopId/visualizations/main/timeline/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane/'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/table/'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/table/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth-error'
    | '/idp-login'
    | '/signup'
    | '/terms'
    | '/'
    | '/organizations/invites'
    | '/invites/auto-accept'
    | '/link-identity/callback'
    | '/organizations/not-a-member'
    | '/organizations/start'
    | '/invites'
    | '/org'
    | '/profile'
    | '/link-identity'
    | '/login'
    | '/organization-selector'
    | '/org/$org/loop'
    | '/integrations/$provider/callback'
    | '/integrations/github/callback'
    | '/integrations/jira/callback'
    | '/integrations/slack/callback'
    | '/org-id/$orgId/$'
    | '/organizations/invites/accept'
    | '/org/$org'
    | '/org/$org/audit/$entityId'
    | '/org/$org/idea-management/$'
    | '/org/$org/intake/custom-fields'
    | '/org/$org/intake/overview'
    | '/org/$org/intake/priority-frameworks'
    | '/published/v1/swimlane/$linkId'
    | '/published/v1/timeline/$linkId'
    | '/org/$org/all-items'
    | '/org/$org/dashboards'
    | '/org/$org/demand'
    | '/org/$org/idea-management'
    | '/org/$org/intake'
    | '/org/$org/loop-intelligence'
    | '/org/$org/notifications'
    | '/org/$org/objectives'
    | '/org/$org/settings'
    | '/org/$org/sir-debug'
    | '/org/$org/visualizations'
    | '/organizations/invites/error'
    | '/org/$org/settings/notifications/slack_app_health'
    | '/org/$org/settings/oauth-clients/$id'
    | '/org/$org/settings/open-positions/hired'
    | '/org/$org/dashboards/$dashboardId'
    | '/org/$org/intake/customers'
    | '/org/$org/intake/demands'
    | '/org/$org/intake/ideas'
    | '/org/$org/intake/inbox'
    | '/org/$org/intake/portals'
    | '/org/$org/intake/product-areas'
    | '/org/$org/loop/$loopId'
    | '/org/$org/settings/accounting-sandbox'
    | '/org/$org/settings/audit'
    | '/org/$org/settings/capacity'
    | '/org/$org/settings/connections'
    | '/org/$org/settings/credits'
    | '/org/$org/settings/currency'
    | '/org/$org/settings/custom-fields'
    | '/org/$org/settings/custom-item-status'
    | '/org/$org/settings/domains'
    | '/org/$org/settings/effort-estimation'
    | '/org/$org/settings/item-types'
    | '/org/$org/settings/location'
    | '/org/$org/settings/notifications'
    | '/org/$org/settings/oauth-clients'
    | '/org/$org/settings/open-positions'
    | '/org/$org/settings/organization'
    | '/org/$org/settings/people'
    | '/org/$org/settings/roles'
    | '/org/$org/settings/skills'
    | '/org/$org/settings/subscriptions'
    | '/org/$org/settings/teams'
    | '/org/$org/settings/user-management'
    | '/org/$org/settings/work-integrations'
    | '/org/$org/settings/work-item-usage'
    | '/export/v1/loop-visualization/dashboard/$dashboardId/png'
    | '/export/v1/loop-visualization/dashboard/$dashboardId/svg'
    | '/org/$org/dashboards/generated/$dashboardId'
    | '/org/$org/intake/demands/statuses'
    | '/org/$org/intake/demands/views'
    | '/org/$org/intake/ideas/all'
    | '/org/$org/intake/ideas/completed'
    | '/org/$org/intake/ideas/create'
    | '/org/$org/intake/ideas/view'
    | '/org/$org/intake/portals/$portalId'
    | '/org/$org/intake/portals/create'
    | '/org/$org/intake/product-areas/$productAreaId'
    | '/org/$org/intake/product-areas/create'
    | '/org/$org/loop/$loopId/dashboard'
    | '/org/$org/loop/$loopId/financials'
    | '/org/$org/loop/$loopId/integrations'
    | '/org/$org/loop/$loopId/intelligence'
    | '/org/$org/loop/$loopId/loop-intelligence'
    | '/org/$org/loop/$loopId/overview'
    | '/org/$org/loop/$loopId/planner'
    | '/org/$org/loop/$loopId/portfolio'
    | '/org/$org/loop/$loopId/strategy'
    | '/org/$org/loop/$loopId/teams'
    | '/org/$org/loop/$loopId/visualizations'
    | '/org/$org/settings/capacity/holiday-scheme'
    | '/org/$org/settings/capacity/orphaned-data'
    | '/org/$org/settings/capacity/workload-scheme'
    | '/org/$org/settings/notifications/subscriptions'
    | '/org/$org/settings/user-management/invites'
    | '/org/$org/settings/user-management/users'
    | '/org/$org/settings/work-integrations/$integrationId'
    | '/org/$org/intake/ideas/view/$viewId'
    | '/org/$org/intake/portals/$portalId/$formId'
    | '/org/$org/loop/$loopId/dashboard/deliverables'
    | '/org/$org/loop/$loopId/planner/live'
    | '/org/$org/loop/$loopId/portfolio/node-graph'
    | '/org/$org/loop/$loopId/portfolio/swimlane'
    | '/org/$org/loop/$loopId/portfolio/table'
    | '/org/$org/loop/$loopId/portfolio/timeline'
    | '/org/$org/loop/$loopId/strategy/manage'
    | '/org/$org/loop/$loopId/visualizations/main'
    | '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId'
    | '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId'
    | '/org/$org/settings/notifications/subscriptions/idea-manager'
    | '/org/$org/settings/teams/team/$teamId'
    | '/org/$org/settings/user-management/users/$userId'
    | '/org/$org/settings/work-integrations/$integrationId/issues'
    | '/org/$org/settings/work-integrations/$integrationId/logs'
    | '/org/$org/intake/demands/views/view/$viewId'
    | '/org/$org/loop/$loopId/planner/live/table'
    | '/org/$org/loop/$loopId/planner/live/timeline'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId'
    | '/org/$org/loop/$loopId/visualizations/main/node-graph'
    | '/org/$org/loop/$loopId/visualizations/main/swimlane'
    | '/org/$org/loop/$loopId/visualizations/main/table'
    | '/org/$org/loop/$loopId/visualizations/main/timeline'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
    | '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table'
    | '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/table'
    | '/org/$org/loop/$loopId/portfolio/view/$viewId/timeline'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/table'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
    | '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
  id:
    | '__root__'
    | '/(app)'
    | '/(unauthenticated)/auth-error'
    | '/(unauthenticated)/idp-login'
    | '/(unauthenticated)/signup'
    | '/(unauthenticated)/terms'
    | '/(app)/'
    | '/(app)/org/$org'
    | '/(unauthenticated)/organizations/invites'
    | '/(app)/invites/auto-accept'
    | '/(unauthenticated)/link-identity/callback'
    | '/(unauthenticated)/organizations/not-a-member'
    | '/(unauthenticated)/organizations/start'
    | '/(app)/invites/'
    | '/(app)/org/'
    | '/(app)/profile/'
    | '/(unauthenticated)/link-identity/'
    | '/(unauthenticated)/login/'
    | '/(unauthenticated)/organization-selector/'
    | '/(app)/org/$org/intake'
    | '/(app)/org/$org/loop'
    | '/(app)/org/$org/loop-intelligence'
    | '/(app)/org/$org/settings'
    | '/(app)/integrations/$provider/callback'
    | '/(app)/integrations/github/callback'
    | '/(app)/integrations/jira/callback'
    | '/(app)/integrations/slack/callback'
    | '/(app)/org-id/$orgId/$'
    | '/(unauthenticated)/organizations/invites/accept'
    | '/(app)/org/$org/'
    | '/(app)/org/$org/intake/inbox'
    | '/(app)/org/$org/intake/portals'
    | '/(app)/org/$org/loop/$loopId'
    | '/(app)/org/$org/settings/capacity'
    | '/(app)/org/$org/settings/connections'
    | '/(app)/org/$org/settings/credits'
    | '/(app)/org/$org/settings/currency'
    | '/(app)/org/$org/settings/domains'
    | '/(app)/org/$org/settings/location'
    | '/(app)/org/$org/settings/oauth-clients'
    | '/(app)/org/$org/settings/open-positions'
    | '/(app)/org/$org/settings/organization'
    | '/(app)/org/$org/settings/people'
    | '/(app)/org/$org/settings/roles'
    | '/(app)/org/$org/settings/skills'
    | '/(app)/org/$org/settings/subscriptions'
    | '/(app)/org/$org/settings/teams'
    | '/(app)/org/$org/settings/user-management'
    | '/(app)/org/$org/settings/work-item-usage'
    | '/(app)/org/$org/audit/$entityId'
    | '/(app)/org/$org/idea-management/$'
    | '/(app)/org/$org/intake/custom-fields'
    | '/(app)/org/$org/intake/overview'
    | '/(app)/org/$org/intake/priority-frameworks'
    | '/(unauthenticated)/published/v1/swimlane/$linkId'
    | '/(unauthenticated)/published/v1/timeline/$linkId'
    | '/(app)/org/$org/all-items/'
    | '/(app)/org/$org/dashboards/'
    | '/(app)/org/$org/demand/'
    | '/(app)/org/$org/idea-management/'
    | '/(app)/org/$org/intake/'
    | '/(app)/org/$org/loop-intelligence/'
    | '/(app)/org/$org/notifications/'
    | '/(app)/org/$org/objectives/'
    | '/(app)/org/$org/settings/'
    | '/(app)/org/$org/sir-debug/'
    | '/(app)/org/$org/visualizations/'
    | '/(unauthenticated)/organizations/invites/error/'
    | '/(app)/org/$org/loop/$loopId/dashboard'
    | '/(app)/org/$org/loop/$loopId/planner'
    | '/(app)/org/$org/loop/$loopId/portfolio'
    | '/(app)/org/$org/loop/$loopId/teams'
    | '/(app)/org/$org/loop/$loopId/visualizations'
    | '/(app)/org/$org/settings/notifications/subscriptions'
    | '/(app)/org/$org/settings/user-management/users'
    | '/(app)/org/$org/settings/work-integrations/$integrationId'
    | '/(app)/org/$org/settings/notifications/slack_app_health'
    | '/(app)/org/$org/settings/oauth-clients/$id'
    | '/(app)/org/$org/settings/open-positions/hired'
    | '/(app)/org/$org/dashboards/$dashboardId/'
    | '/(app)/org/$org/intake/customers/'
    | '/(app)/org/$org/intake/demands/'
    | '/(app)/org/$org/intake/ideas/'
    | '/(app)/org/$org/intake/inbox/'
    | '/(app)/org/$org/intake/portals/'
    | '/(app)/org/$org/intake/product-areas/'
    | '/(app)/org/$org/loop/$loopId/'
    | '/(app)/org/$org/settings/accounting-sandbox/'
    | '/(app)/org/$org/settings/audit/'
    | '/(app)/org/$org/settings/capacity/'
    | '/(app)/org/$org/settings/connections/'
    | '/(app)/org/$org/settings/credits/'
    | '/(app)/org/$org/settings/currency/'
    | '/(app)/org/$org/settings/custom-fields/'
    | '/(app)/org/$org/settings/custom-item-status/'
    | '/(app)/org/$org/settings/domains/'
    | '/(app)/org/$org/settings/effort-estimation/'
    | '/(app)/org/$org/settings/item-types/'
    | '/(app)/org/$org/settings/location/'
    | '/(app)/org/$org/settings/notifications/'
    | '/(app)/org/$org/settings/oauth-clients/'
    | '/(app)/org/$org/settings/open-positions/'
    | '/(app)/org/$org/settings/organization/'
    | '/(app)/org/$org/settings/people/'
    | '/(app)/org/$org/settings/roles/'
    | '/(app)/org/$org/settings/skills/'
    | '/(app)/org/$org/settings/subscriptions/'
    | '/(app)/org/$org/settings/teams/'
    | '/(app)/org/$org/settings/user-management/'
    | '/(app)/org/$org/settings/work-integrations/'
    | '/(app)/org/$org/settings/work-item-usage/'
    | '/(app)/org/$org/loop/$loopId/planner/live'
    | '/(app)/org/$org/loop/$loopId/visualizations/main'
    | '/(app)/org/$org/settings/teams/team/$teamId'
    | '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/png'
    | '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/svg'
    | '/(app)/org/$org/dashboards/generated/$dashboardId/'
    | '/(app)/org/$org/intake/demands/statuses/'
    | '/(app)/org/$org/intake/demands/views/'
    | '/(app)/org/$org/intake/ideas/all/'
    | '/(app)/org/$org/intake/ideas/completed/'
    | '/(app)/org/$org/intake/ideas/create/'
    | '/(app)/org/$org/intake/ideas/view/'
    | '/(app)/org/$org/intake/portals/$portalId/'
    | '/(app)/org/$org/intake/portals/create/'
    | '/(app)/org/$org/intake/product-areas/$productAreaId/'
    | '/(app)/org/$org/intake/product-areas/create/'
    | '/(app)/org/$org/loop/$loopId/dashboard/'
    | '/(app)/org/$org/loop/$loopId/financials/'
    | '/(app)/org/$org/loop/$loopId/integrations/'
    | '/(app)/org/$org/loop/$loopId/intelligence/'
    | '/(app)/org/$org/loop/$loopId/loop-intelligence/'
    | '/(app)/org/$org/loop/$loopId/overview/'
    | '/(app)/org/$org/loop/$loopId/planner/'
    | '/(app)/org/$org/loop/$loopId/portfolio/'
    | '/(app)/org/$org/loop/$loopId/strategy/'
    | '/(app)/org/$org/loop/$loopId/teams/'
    | '/(app)/org/$org/loop/$loopId/visualizations/'
    | '/(app)/org/$org/settings/capacity/holiday-scheme/'
    | '/(app)/org/$org/settings/capacity/orphaned-data/'
    | '/(app)/org/$org/settings/capacity/workload-scheme/'
    | '/(app)/org/$org/settings/notifications/subscriptions/'
    | '/(app)/org/$org/settings/user-management/invites/'
    | '/(app)/org/$org/settings/user-management/users/'
    | '/(app)/org/$org/settings/work-integrations/$integrationId/'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId'
    | '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId'
    | '/(app)/org/$org/intake/ideas/view/$viewId/'
    | '/(app)/org/$org/intake/portals/$portalId/$formId/'
    | '/(app)/org/$org/loop/$loopId/dashboard/deliverables/'
    | '/(app)/org/$org/loop/$loopId/planner/live/'
    | '/(app)/org/$org/loop/$loopId/portfolio/node-graph/'
    | '/(app)/org/$org/loop/$loopId/portfolio/swimlane/'
    | '/(app)/org/$org/loop/$loopId/portfolio/table/'
    | '/(app)/org/$org/loop/$loopId/portfolio/timeline/'
    | '/(app)/org/$org/loop/$loopId/strategy/manage/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/'
    | '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
    | '/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/'
    | '/(app)/org/$org/settings/notifications/subscriptions/idea-manager/'
    | '/(app)/org/$org/settings/teams/team/$teamId/'
    | '/(app)/org/$org/settings/user-management/users/$userId/'
    | '/(app)/org/$org/settings/work-integrations/$integrationId/issues/'
    | '/(app)/org/$org/settings/work-integrations/$integrationId/logs/'
    | '/(app)/org/$org/intake/demands/views/view/$viewId/'
    | '/(app)/org/$org/loop/$loopId/planner/live/table/'
    | '/(app)/org/$org/loop/$loopId/planner/live/timeline/'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/'
    | '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/node-graph/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/table/'
    | '/(app)/org/$org/loop/$loopId/visualizations/main/timeline/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
    | '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/'
    | '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/'
    | '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/'
    | '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane/'
    | '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/table/'
    | '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
    | '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
  unauthenticatedAuthErrorRoute: typeof unauthenticatedAuthErrorRoute
  unauthenticatedIdpLoginRoute: typeof unauthenticatedIdpLoginRoute
  unauthenticatedSignupRoute: typeof unauthenticatedSignupRoute
  unauthenticatedTermsRoute: typeof unauthenticatedTermsRoute
  unauthenticatedOrganizationsInvitesRouteRoute: typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  unauthenticatedLinkIdentityCallbackRoute: typeof unauthenticatedLinkIdentityCallbackRoute
  unauthenticatedOrganizationsNotAMemberRoute: typeof unauthenticatedOrganizationsNotAMemberRoute
  unauthenticatedOrganizationsStartRoute: typeof unauthenticatedOrganizationsStartRoute
  unauthenticatedLinkIdentityIndexRoute: typeof unauthenticatedLinkIdentityIndexRoute
  unauthenticatedLoginIndexRoute: typeof unauthenticatedLoginIndexRoute
  unauthenticatedOrganizationSelectorIndexRoute: typeof unauthenticatedOrganizationSelectorIndexRoute
  unauthenticatedPublishedV1SwimlaneLinkIdRoute: typeof unauthenticatedPublishedV1SwimlaneLinkIdRoute
  unauthenticatedPublishedV1TimelineLinkIdRoute: typeof unauthenticatedPublishedV1TimelineLinkIdRoute
  unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRoute: typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRoute
  unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRoute: typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/': {
      id: '/(app)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(unauthenticated)/terms': {
      id: '/(unauthenticated)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof unauthenticatedTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/signup': {
      id: '/(unauthenticated)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof unauthenticatedSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/idp-login': {
      id: '/(unauthenticated)/idp-login'
      path: '/idp-login'
      fullPath: '/idp-login'
      preLoaderRoute: typeof unauthenticatedIdpLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/auth-error': {
      id: '/(unauthenticated)/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof unauthenticatedAuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/organization-selector/': {
      id: '/(unauthenticated)/organization-selector/'
      path: '/organization-selector'
      fullPath: '/organization-selector/'
      preLoaderRoute: typeof unauthenticatedOrganizationSelectorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/login/': {
      id: '/(unauthenticated)/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof unauthenticatedLoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/link-identity/': {
      id: '/(unauthenticated)/link-identity/'
      path: '/link-identity'
      fullPath: '/link-identity/'
      preLoaderRoute: typeof unauthenticatedLinkIdentityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/profile/': {
      id: '/(app)/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof appProfileIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/org/': {
      id: '/(app)/org/'
      path: '/org'
      fullPath: '/org/'
      preLoaderRoute: typeof appOrgIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/invites/': {
      id: '/(app)/invites/'
      path: '/invites'
      fullPath: '/invites/'
      preLoaderRoute: typeof appInvitesIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(unauthenticated)/organizations/start': {
      id: '/(unauthenticated)/organizations/start'
      path: '/organizations/start'
      fullPath: '/organizations/start'
      preLoaderRoute: typeof unauthenticatedOrganizationsStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/organizations/not-a-member': {
      id: '/(unauthenticated)/organizations/not-a-member'
      path: '/organizations/not-a-member'
      fullPath: '/organizations/not-a-member'
      preLoaderRoute: typeof unauthenticatedOrganizationsNotAMemberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/link-identity/callback': {
      id: '/(unauthenticated)/link-identity/callback'
      path: '/link-identity/callback'
      fullPath: '/link-identity/callback'
      preLoaderRoute: typeof unauthenticatedLinkIdentityCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/invites/auto-accept': {
      id: '/(app)/invites/auto-accept'
      path: '/invites/auto-accept'
      fullPath: '/invites/auto-accept'
      preLoaderRoute: typeof appInvitesAutoAcceptRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(unauthenticated)/organizations/invites': {
      id: '/(unauthenticated)/organizations/invites'
      path: '/organizations/invites'
      fullPath: '/organizations/invites'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org': {
      id: '/(app)/org/$org'
      path: '/org/$org'
      fullPath: '/org/$org'
      preLoaderRoute: typeof appOrgOrgRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/org/$org/': {
      id: '/(app)/org/$org/'
      path: '/'
      fullPath: '/org/$org/'
      preLoaderRoute: typeof appOrgOrgIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/organizations/invites/accept': {
      id: '/(unauthenticated)/organizations/invites/accept'
      path: '/accept'
      fullPath: '/organizations/invites/accept'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesAcceptRouteImport
      parentRoute: typeof unauthenticatedOrganizationsInvitesRouteRoute
    }
    '/(app)/org-id/$orgId/$': {
      id: '/(app)/org-id/$orgId/$'
      path: '/org-id/$orgId/$'
      fullPath: '/org-id/$orgId/$'
      preLoaderRoute: typeof appOrgIdOrgIdSplatRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/integrations/slack/callback': {
      id: '/(app)/integrations/slack/callback'
      path: '/integrations/slack/callback'
      fullPath: '/integrations/slack/callback'
      preLoaderRoute: typeof appIntegrationsSlackCallbackRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/integrations/jira/callback': {
      id: '/(app)/integrations/jira/callback'
      path: '/integrations/jira/callback'
      fullPath: '/integrations/jira/callback'
      preLoaderRoute: typeof appIntegrationsJiraCallbackRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/integrations/github/callback': {
      id: '/(app)/integrations/github/callback'
      path: '/integrations/github/callback'
      fullPath: '/integrations/github/callback'
      preLoaderRoute: typeof appIntegrationsGithubCallbackRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/integrations/$provider/callback': {
      id: '/(app)/integrations/$provider/callback'
      path: '/integrations/$provider/callback'
      fullPath: '/integrations/$provider/callback'
      preLoaderRoute: typeof appIntegrationsProviderCallbackRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/org/$org/settings': {
      id: '/(app)/org/$org/settings'
      path: '/settings'
      fullPath: '/org/$org/settings'
      preLoaderRoute: typeof appOrgOrgSettingsRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/loop-intelligence': {
      id: '/(app)/org/$org/loop-intelligence'
      path: '/loop-intelligence'
      fullPath: '/org/$org/loop-intelligence'
      preLoaderRoute: typeof appOrgOrgLoopIntelligenceRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/loop': {
      id: '/(app)/org/$org/loop'
      path: '/loop'
      fullPath: '/org/$org/loop'
      preLoaderRoute: typeof appOrgOrgLoopRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/intake': {
      id: '/(app)/org/$org/intake'
      path: '/intake'
      fullPath: '/org/$org/intake'
      preLoaderRoute: typeof appOrgOrgIntakeRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/organizations/invites/error/': {
      id: '/(unauthenticated)/organizations/invites/error/'
      path: '/error'
      fullPath: '/organizations/invites/error/'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesErrorIndexRouteImport
      parentRoute: typeof unauthenticatedOrganizationsInvitesRouteRoute
    }
    '/(app)/org/$org/visualizations/': {
      id: '/(app)/org/$org/visualizations/'
      path: '/visualizations'
      fullPath: '/org/$org/visualizations/'
      preLoaderRoute: typeof appOrgOrgVisualizationsIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/sir-debug/': {
      id: '/(app)/org/$org/sir-debug/'
      path: '/sir-debug'
      fullPath: '/org/$org/sir-debug/'
      preLoaderRoute: typeof appOrgOrgSirDebugIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/settings/': {
      id: '/(app)/org/$org/settings/'
      path: '/'
      fullPath: '/org/$org/settings/'
      preLoaderRoute: typeof appOrgOrgSettingsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/objectives/': {
      id: '/(app)/org/$org/objectives/'
      path: '/objectives'
      fullPath: '/org/$org/objectives/'
      preLoaderRoute: typeof appOrgOrgObjectivesIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/notifications/': {
      id: '/(app)/org/$org/notifications/'
      path: '/notifications'
      fullPath: '/org/$org/notifications/'
      preLoaderRoute: typeof appOrgOrgNotificationsIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/loop-intelligence/': {
      id: '/(app)/org/$org/loop-intelligence/'
      path: '/'
      fullPath: '/org/$org/loop-intelligence/'
      preLoaderRoute: typeof appOrgOrgLoopIntelligenceIndexRouteImport
      parentRoute: typeof appOrgOrgLoopIntelligenceRouteRoute
    }
    '/(app)/org/$org/intake/': {
      id: '/(app)/org/$org/intake/'
      path: '/'
      fullPath: '/org/$org/intake/'
      preLoaderRoute: typeof appOrgOrgIntakeIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/idea-management/': {
      id: '/(app)/org/$org/idea-management/'
      path: '/idea-management'
      fullPath: '/org/$org/idea-management/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/demand/': {
      id: '/(app)/org/$org/demand/'
      path: '/demand'
      fullPath: '/org/$org/demand/'
      preLoaderRoute: typeof appOrgOrgDemandIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/dashboards/': {
      id: '/(app)/org/$org/dashboards/'
      path: '/dashboards'
      fullPath: '/org/$org/dashboards/'
      preLoaderRoute: typeof appOrgOrgDashboardsIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/all-items/': {
      id: '/(app)/org/$org/all-items/'
      path: '/all-items'
      fullPath: '/org/$org/all-items/'
      preLoaderRoute: typeof appOrgOrgAllItemsIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/published/v1/timeline/$linkId': {
      id: '/(unauthenticated)/published/v1/timeline/$linkId'
      path: '/published/v1/timeline/$linkId'
      fullPath: '/published/v1/timeline/$linkId'
      preLoaderRoute: typeof unauthenticatedPublishedV1TimelineLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/published/v1/swimlane/$linkId': {
      id: '/(unauthenticated)/published/v1/swimlane/$linkId'
      path: '/published/v1/swimlane/$linkId'
      fullPath: '/published/v1/swimlane/$linkId'
      preLoaderRoute: typeof unauthenticatedPublishedV1SwimlaneLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org/intake/priority-frameworks': {
      id: '/(app)/org/$org/intake/priority-frameworks'
      path: '/priority-frameworks'
      fullPath: '/org/$org/intake/priority-frameworks'
      preLoaderRoute: typeof appOrgOrgIntakePriorityFrameworksRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/overview': {
      id: '/(app)/org/$org/intake/overview'
      path: '/overview'
      fullPath: '/org/$org/intake/overview'
      preLoaderRoute: typeof appOrgOrgIntakeOverviewRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/custom-fields': {
      id: '/(app)/org/$org/intake/custom-fields'
      path: '/custom-fields'
      fullPath: '/org/$org/intake/custom-fields'
      preLoaderRoute: typeof appOrgOrgIntakeCustomFieldsRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/idea-management/$': {
      id: '/(app)/org/$org/idea-management/$'
      path: '/idea-management/$'
      fullPath: '/org/$org/idea-management/$'
      preLoaderRoute: typeof appOrgOrgIdeaManagementSplatRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/audit/$entityId': {
      id: '/(app)/org/$org/audit/$entityId'
      path: '/audit/$entityId'
      fullPath: '/org/$org/audit/$entityId'
      preLoaderRoute: typeof appOrgOrgAuditEntityIdRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/settings/work-item-usage': {
      id: '/(app)/org/$org/settings/work-item-usage'
      path: '/work-item-usage'
      fullPath: '/org/$org/settings/work-item-usage'
      preLoaderRoute: typeof appOrgOrgSettingsWorkItemUsageRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/user-management': {
      id: '/(app)/org/$org/settings/user-management'
      path: '/user-management'
      fullPath: '/org/$org/settings/user-management'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/teams': {
      id: '/(app)/org/$org/settings/teams'
      path: '/teams'
      fullPath: '/org/$org/settings/teams'
      preLoaderRoute: typeof appOrgOrgSettingsTeamsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/subscriptions': {
      id: '/(app)/org/$org/settings/subscriptions'
      path: '/subscriptions'
      fullPath: '/org/$org/settings/subscriptions'
      preLoaderRoute: typeof appOrgOrgSettingsSubscriptionsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/skills': {
      id: '/(app)/org/$org/settings/skills'
      path: '/skills'
      fullPath: '/org/$org/settings/skills'
      preLoaderRoute: typeof appOrgOrgSettingsSkillsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/roles': {
      id: '/(app)/org/$org/settings/roles'
      path: '/roles'
      fullPath: '/org/$org/settings/roles'
      preLoaderRoute: typeof appOrgOrgSettingsRolesRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/people': {
      id: '/(app)/org/$org/settings/people'
      path: '/people'
      fullPath: '/org/$org/settings/people'
      preLoaderRoute: typeof appOrgOrgSettingsPeopleRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/organization': {
      id: '/(app)/org/$org/settings/organization'
      path: '/organization'
      fullPath: '/org/$org/settings/organization'
      preLoaderRoute: typeof appOrgOrgSettingsOrganizationRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/open-positions': {
      id: '/(app)/org/$org/settings/open-positions'
      path: '/open-positions'
      fullPath: '/org/$org/settings/open-positions'
      preLoaderRoute: typeof appOrgOrgSettingsOpenPositionsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/oauth-clients': {
      id: '/(app)/org/$org/settings/oauth-clients'
      path: '/oauth-clients'
      fullPath: '/org/$org/settings/oauth-clients'
      preLoaderRoute: typeof appOrgOrgSettingsOauthClientsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/location': {
      id: '/(app)/org/$org/settings/location'
      path: '/location'
      fullPath: '/org/$org/settings/location'
      preLoaderRoute: typeof appOrgOrgSettingsLocationRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/domains': {
      id: '/(app)/org/$org/settings/domains'
      path: '/domains'
      fullPath: '/org/$org/settings/domains'
      preLoaderRoute: typeof appOrgOrgSettingsDomainsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/currency': {
      id: '/(app)/org/$org/settings/currency'
      path: '/currency'
      fullPath: '/org/$org/settings/currency'
      preLoaderRoute: typeof appOrgOrgSettingsCurrencyRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/credits': {
      id: '/(app)/org/$org/settings/credits'
      path: '/credits'
      fullPath: '/org/$org/settings/credits'
      preLoaderRoute: typeof appOrgOrgSettingsCreditsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/connections': {
      id: '/(app)/org/$org/settings/connections'
      path: '/connections'
      fullPath: '/org/$org/settings/connections'
      preLoaderRoute: typeof appOrgOrgSettingsConnectionsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/capacity': {
      id: '/(app)/org/$org/settings/capacity'
      path: '/capacity'
      fullPath: '/org/$org/settings/capacity'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId': {
      id: '/(app)/org/$org/loop/$loopId'
      path: '/$loopId'
      fullPath: '/org/$org/loop/$loopId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopRouteRoute
    }
    '/(app)/org/$org/intake/portals': {
      id: '/(app)/org/$org/intake/portals'
      path: '/portals'
      fullPath: '/org/$org/intake/portals'
      preLoaderRoute: typeof appOrgOrgIntakePortalsRouteRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/inbox': {
      id: '/(app)/org/$org/intake/inbox'
      path: '/inbox'
      fullPath: '/org/$org/intake/inbox'
      preLoaderRoute: typeof appOrgOrgIntakeInboxRouteRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/settings/work-item-usage/': {
      id: '/(app)/org/$org/settings/work-item-usage/'
      path: '/'
      fullPath: '/org/$org/settings/work-item-usage/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkItemUsageIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsWorkItemUsageRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/': {
      id: '/(app)/org/$org/settings/work-integrations/'
      path: '/work-integrations'
      fullPath: '/org/$org/settings/work-integrations/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/user-management/': {
      id: '/(app)/org/$org/settings/user-management/'
      path: '/'
      fullPath: '/org/$org/settings/user-management/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/settings/teams/': {
      id: '/(app)/org/$org/settings/teams/'
      path: '/'
      fullPath: '/org/$org/settings/teams/'
      preLoaderRoute: typeof appOrgOrgSettingsTeamsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsTeamsRouteRoute
    }
    '/(app)/org/$org/settings/subscriptions/': {
      id: '/(app)/org/$org/settings/subscriptions/'
      path: '/'
      fullPath: '/org/$org/settings/subscriptions/'
      preLoaderRoute: typeof appOrgOrgSettingsSubscriptionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsSubscriptionsRouteRoute
    }
    '/(app)/org/$org/settings/skills/': {
      id: '/(app)/org/$org/settings/skills/'
      path: '/'
      fullPath: '/org/$org/settings/skills/'
      preLoaderRoute: typeof appOrgOrgSettingsSkillsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsSkillsRouteRoute
    }
    '/(app)/org/$org/settings/roles/': {
      id: '/(app)/org/$org/settings/roles/'
      path: '/'
      fullPath: '/org/$org/settings/roles/'
      preLoaderRoute: typeof appOrgOrgSettingsRolesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRolesRouteRoute
    }
    '/(app)/org/$org/settings/people/': {
      id: '/(app)/org/$org/settings/people/'
      path: '/'
      fullPath: '/org/$org/settings/people/'
      preLoaderRoute: typeof appOrgOrgSettingsPeopleIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsPeopleRouteRoute
    }
    '/(app)/org/$org/settings/organization/': {
      id: '/(app)/org/$org/settings/organization/'
      path: '/'
      fullPath: '/org/$org/settings/organization/'
      preLoaderRoute: typeof appOrgOrgSettingsOrganizationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsOrganizationRouteRoute
    }
    '/(app)/org/$org/settings/open-positions/': {
      id: '/(app)/org/$org/settings/open-positions/'
      path: '/'
      fullPath: '/org/$org/settings/open-positions/'
      preLoaderRoute: typeof appOrgOrgSettingsOpenPositionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsOpenPositionsRouteRoute
    }
    '/(app)/org/$org/settings/oauth-clients/': {
      id: '/(app)/org/$org/settings/oauth-clients/'
      path: '/'
      fullPath: '/org/$org/settings/oauth-clients/'
      preLoaderRoute: typeof appOrgOrgSettingsOauthClientsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsOauthClientsRouteRoute
    }
    '/(app)/org/$org/settings/notifications/': {
      id: '/(app)/org/$org/settings/notifications/'
      path: '/notifications'
      fullPath: '/org/$org/settings/notifications/'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/location/': {
      id: '/(app)/org/$org/settings/location/'
      path: '/'
      fullPath: '/org/$org/settings/location/'
      preLoaderRoute: typeof appOrgOrgSettingsLocationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsLocationRouteRoute
    }
    '/(app)/org/$org/settings/item-types/': {
      id: '/(app)/org/$org/settings/item-types/'
      path: '/item-types'
      fullPath: '/org/$org/settings/item-types/'
      preLoaderRoute: typeof appOrgOrgSettingsItemTypesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/effort-estimation/': {
      id: '/(app)/org/$org/settings/effort-estimation/'
      path: '/effort-estimation'
      fullPath: '/org/$org/settings/effort-estimation/'
      preLoaderRoute: typeof appOrgOrgSettingsEffortEstimationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/domains/': {
      id: '/(app)/org/$org/settings/domains/'
      path: '/'
      fullPath: '/org/$org/settings/domains/'
      preLoaderRoute: typeof appOrgOrgSettingsDomainsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsDomainsRouteRoute
    }
    '/(app)/org/$org/settings/custom-item-status/': {
      id: '/(app)/org/$org/settings/custom-item-status/'
      path: '/custom-item-status'
      fullPath: '/org/$org/settings/custom-item-status/'
      preLoaderRoute: typeof appOrgOrgSettingsCustomItemStatusIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/custom-fields/': {
      id: '/(app)/org/$org/settings/custom-fields/'
      path: '/custom-fields'
      fullPath: '/org/$org/settings/custom-fields/'
      preLoaderRoute: typeof appOrgOrgSettingsCustomFieldsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/currency/': {
      id: '/(app)/org/$org/settings/currency/'
      path: '/'
      fullPath: '/org/$org/settings/currency/'
      preLoaderRoute: typeof appOrgOrgSettingsCurrencyIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCurrencyRouteRoute
    }
    '/(app)/org/$org/settings/credits/': {
      id: '/(app)/org/$org/settings/credits/'
      path: '/'
      fullPath: '/org/$org/settings/credits/'
      preLoaderRoute: typeof appOrgOrgSettingsCreditsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCreditsRouteRoute
    }
    '/(app)/org/$org/settings/connections/': {
      id: '/(app)/org/$org/settings/connections/'
      path: '/'
      fullPath: '/org/$org/settings/connections/'
      preLoaderRoute: typeof appOrgOrgSettingsConnectionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsConnectionsRouteRoute
    }
    '/(app)/org/$org/settings/capacity/': {
      id: '/(app)/org/$org/settings/capacity/'
      path: '/'
      fullPath: '/org/$org/settings/capacity/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/settings/audit/': {
      id: '/(app)/org/$org/settings/audit/'
      path: '/audit'
      fullPath: '/org/$org/settings/audit/'
      preLoaderRoute: typeof appOrgOrgSettingsAuditIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/accounting-sandbox/': {
      id: '/(app)/org/$org/settings/accounting-sandbox/'
      path: '/accounting-sandbox'
      fullPath: '/org/$org/settings/accounting-sandbox/'
      preLoaderRoute: typeof appOrgOrgSettingsAccountingSandboxIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/': {
      id: '/(app)/org/$org/loop/$loopId/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/intake/product-areas/': {
      id: '/(app)/org/$org/intake/product-areas/'
      path: '/product-areas'
      fullPath: '/org/$org/intake/product-areas/'
      preLoaderRoute: typeof appOrgOrgIntakeProductAreasIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/portals/': {
      id: '/(app)/org/$org/intake/portals/'
      path: '/'
      fullPath: '/org/$org/intake/portals/'
      preLoaderRoute: typeof appOrgOrgIntakePortalsIndexRouteImport
      parentRoute: typeof appOrgOrgIntakePortalsRouteRoute
    }
    '/(app)/org/$org/intake/inbox/': {
      id: '/(app)/org/$org/intake/inbox/'
      path: '/'
      fullPath: '/org/$org/intake/inbox/'
      preLoaderRoute: typeof appOrgOrgIntakeInboxIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeInboxRouteRoute
    }
    '/(app)/org/$org/intake/ideas/': {
      id: '/(app)/org/$org/intake/ideas/'
      path: '/ideas'
      fullPath: '/org/$org/intake/ideas/'
      preLoaderRoute: typeof appOrgOrgIntakeIdeasIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/demands/': {
      id: '/(app)/org/$org/intake/demands/'
      path: '/demands'
      fullPath: '/org/$org/intake/demands/'
      preLoaderRoute: typeof appOrgOrgIntakeDemandsIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/customers/': {
      id: '/(app)/org/$org/intake/customers/'
      path: '/customers'
      fullPath: '/org/$org/intake/customers/'
      preLoaderRoute: typeof appOrgOrgIntakeCustomersIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/dashboards/$dashboardId/': {
      id: '/(app)/org/$org/dashboards/$dashboardId/'
      path: '/dashboards/$dashboardId'
      fullPath: '/org/$org/dashboards/$dashboardId/'
      preLoaderRoute: typeof appOrgOrgDashboardsDashboardIdIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/settings/open-positions/hired': {
      id: '/(app)/org/$org/settings/open-positions/hired'
      path: '/hired'
      fullPath: '/org/$org/settings/open-positions/hired'
      preLoaderRoute: typeof appOrgOrgSettingsOpenPositionsHiredRouteImport
      parentRoute: typeof appOrgOrgSettingsOpenPositionsRouteRoute
    }
    '/(app)/org/$org/settings/oauth-clients/$id': {
      id: '/(app)/org/$org/settings/oauth-clients/$id'
      path: '/$id'
      fullPath: '/org/$org/settings/oauth-clients/$id'
      preLoaderRoute: typeof appOrgOrgSettingsOauthClientsIdRouteImport
      parentRoute: typeof appOrgOrgSettingsOauthClientsRouteRoute
    }
    '/(app)/org/$org/settings/notifications/slack_app_health': {
      id: '/(app)/org/$org/settings/notifications/slack_app_health'
      path: '/notifications/slack_app_health'
      fullPath: '/org/$org/settings/notifications/slack_app_health'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsSlack_app_healthRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/$integrationId': {
      id: '/(app)/org/$org/settings/work-integrations/$integrationId'
      path: '/work-integrations/$integrationId'
      fullPath: '/org/$org/settings/work-integrations/$integrationId'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users': {
      id: '/(app)/org/$org/settings/user-management/users'
      path: '/users'
      fullPath: '/org/$org/settings/user-management/users'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/settings/notifications/subscriptions': {
      id: '/(app)/org/$org/settings/notifications/subscriptions'
      path: '/notifications/subscriptions'
      fullPath: '/org/$org/settings/notifications/subscriptions'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations': {
      id: '/(app)/org/$org/loop/$loopId/visualizations'
      path: '/visualizations'
      fullPath: '/org/$org/loop/$loopId/visualizations'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/teams': {
      id: '/(app)/org/$org/loop/$loopId/teams'
      path: '/teams'
      fullPath: '/org/$org/loop/$loopId/teams'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdTeamsRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio': {
      id: '/(app)/org/$org/loop/$loopId/portfolio'
      path: '/portfolio'
      fullPath: '/org/$org/loop/$loopId/portfolio'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner': {
      id: '/(app)/org/$org/loop/$loopId/planner'
      path: '/planner'
      fullPath: '/org/$org/loop/$loopId/planner'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/dashboard': {
      id: '/(app)/org/$org/loop/$loopId/dashboard'
      path: '/dashboard'
      fullPath: '/org/$org/loop/$loopId/dashboard'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdDashboardRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/$integrationId/': {
      id: '/(app)/org/$org/settings/work-integrations/$integrationId/'
      path: '/'
      fullPath: '/org/$org/settings/work-integrations/$integrationId/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users/': {
      id: '/(app)/org/$org/settings/user-management/users/'
      path: '/'
      fullPath: '/org/$org/settings/user-management/users/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRoute
    }
    '/(app)/org/$org/settings/user-management/invites/': {
      id: '/(app)/org/$org/settings/user-management/invites/'
      path: '/invites'
      fullPath: '/org/$org/settings/user-management/invites/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementInvitesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/settings/notifications/subscriptions/': {
      id: '/(app)/org/$org/settings/notifications/subscriptions/'
      path: '/'
      fullPath: '/org/$org/settings/notifications/subscriptions/'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRoute
    }
    '/(app)/org/$org/settings/capacity/workload-scheme/': {
      id: '/(app)/org/$org/settings/capacity/workload-scheme/'
      path: '/workload-scheme'
      fullPath: '/org/$org/settings/capacity/workload-scheme/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityWorkloadSchemeIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/settings/capacity/orphaned-data/': {
      id: '/(app)/org/$org/settings/capacity/orphaned-data/'
      path: '/orphaned-data'
      fullPath: '/org/$org/settings/capacity/orphaned-data/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityOrphanedDataIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/settings/capacity/holiday-scheme/': {
      id: '/(app)/org/$org/settings/capacity/holiday-scheme/'
      path: '/holiday-scheme'
      fullPath: '/org/$org/settings/capacity/holiday-scheme/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/visualizations/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/teams/': {
      id: '/(app)/org/$org/loop/$loopId/teams/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/teams/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdTeamsIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdTeamsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/strategy/': {
      id: '/(app)/org/$org/loop/$loopId/strategy/'
      path: '/strategy'
      fullPath: '/org/$org/loop/$loopId/strategy/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdStrategyIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/portfolio/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/': {
      id: '/(app)/org/$org/loop/$loopId/planner/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/planner/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/overview/': {
      id: '/(app)/org/$org/loop/$loopId/overview/'
      path: '/overview'
      fullPath: '/org/$org/loop/$loopId/overview/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdOverviewIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/loop-intelligence/': {
      id: '/(app)/org/$org/loop/$loopId/loop-intelligence/'
      path: '/loop-intelligence'
      fullPath: '/org/$org/loop/$loopId/loop-intelligence/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdLoopIntelligenceIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/intelligence/': {
      id: '/(app)/org/$org/loop/$loopId/intelligence/'
      path: '/intelligence'
      fullPath: '/org/$org/loop/$loopId/intelligence/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdIntelligenceIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/integrations/': {
      id: '/(app)/org/$org/loop/$loopId/integrations/'
      path: '/integrations'
      fullPath: '/org/$org/loop/$loopId/integrations/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdIntegrationsIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/financials/': {
      id: '/(app)/org/$org/loop/$loopId/financials/'
      path: '/financials'
      fullPath: '/org/$org/loop/$loopId/financials/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdFinancialsIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/dashboard/': {
      id: '/(app)/org/$org/loop/$loopId/dashboard/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/dashboard/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdDashboardIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdDashboardRouteRoute
    }
    '/(app)/org/$org/intake/product-areas/create/': {
      id: '/(app)/org/$org/intake/product-areas/create/'
      path: '/product-areas/create'
      fullPath: '/org/$org/intake/product-areas/create/'
      preLoaderRoute: typeof appOrgOrgIntakeProductAreasCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/product-areas/$productAreaId/': {
      id: '/(app)/org/$org/intake/product-areas/$productAreaId/'
      path: '/product-areas/$productAreaId'
      fullPath: '/org/$org/intake/product-areas/$productAreaId/'
      preLoaderRoute: typeof appOrgOrgIntakeProductAreasProductAreaIdIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/portals/create/': {
      id: '/(app)/org/$org/intake/portals/create/'
      path: '/create'
      fullPath: '/org/$org/intake/portals/create/'
      preLoaderRoute: typeof appOrgOrgIntakePortalsCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIntakePortalsRouteRoute
    }
    '/(app)/org/$org/intake/portals/$portalId/': {
      id: '/(app)/org/$org/intake/portals/$portalId/'
      path: '/$portalId'
      fullPath: '/org/$org/intake/portals/$portalId/'
      preLoaderRoute: typeof appOrgOrgIntakePortalsPortalIdIndexRouteImport
      parentRoute: typeof appOrgOrgIntakePortalsRouteRoute
    }
    '/(app)/org/$org/intake/ideas/view/': {
      id: '/(app)/org/$org/intake/ideas/view/'
      path: '/ideas/view'
      fullPath: '/org/$org/intake/ideas/view/'
      preLoaderRoute: typeof appOrgOrgIntakeIdeasViewIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/ideas/create/': {
      id: '/(app)/org/$org/intake/ideas/create/'
      path: '/ideas/create'
      fullPath: '/org/$org/intake/ideas/create/'
      preLoaderRoute: typeof appOrgOrgIntakeIdeasCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/ideas/completed/': {
      id: '/(app)/org/$org/intake/ideas/completed/'
      path: '/ideas/completed'
      fullPath: '/org/$org/intake/ideas/completed/'
      preLoaderRoute: typeof appOrgOrgIntakeIdeasCompletedIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/ideas/all/': {
      id: '/(app)/org/$org/intake/ideas/all/'
      path: '/ideas/all'
      fullPath: '/org/$org/intake/ideas/all/'
      preLoaderRoute: typeof appOrgOrgIntakeIdeasAllIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/demands/views/': {
      id: '/(app)/org/$org/intake/demands/views/'
      path: '/demands/views'
      fullPath: '/org/$org/intake/demands/views/'
      preLoaderRoute: typeof appOrgOrgIntakeDemandsViewsIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/intake/demands/statuses/': {
      id: '/(app)/org/$org/intake/demands/statuses/'
      path: '/demands/statuses'
      fullPath: '/org/$org/intake/demands/statuses/'
      preLoaderRoute: typeof appOrgOrgIntakeDemandsStatusesIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/dashboards/generated/$dashboardId/': {
      id: '/(app)/org/$org/dashboards/generated/$dashboardId/'
      path: '/dashboards/generated/$dashboardId'
      fullPath: '/org/$org/dashboards/generated/$dashboardId/'
      preLoaderRoute: typeof appOrgOrgDashboardsGeneratedDashboardIdIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/svg': {
      id: '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/svg'
      path: '/export/v1/loop-visualization/dashboard/$dashboardId/svg'
      fullPath: '/export/v1/loop-visualization/dashboard/$dashboardId/svg'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/png': {
      id: '/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/png'
      path: '/export/v1/loop-visualization/dashboard/$dashboardId/png'
      fullPath: '/export/v1/loop-visualization/dashboard/$dashboardId/png'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org/settings/teams/team/$teamId': {
      id: '/(app)/org/$org/settings/teams/team/$teamId'
      path: '/team/$teamId'
      fullPath: '/org/$org/settings/teams/team/$teamId'
      preLoaderRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsTeamsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main'
      path: '/main'
      fullPath: '/org/$org/loop/$loopId/visualizations/main'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/live': {
      id: '/(app)/org/$org/loop/$loopId/planner/live'
      path: '/live'
      fullPath: '/org/$org/loop/$loopId/planner/live'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerLiveRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/$integrationId/logs/': {
      id: '/(app)/org/$org/settings/work-integrations/$integrationId/logs/'
      path: '/logs'
      fullPath: '/org/$org/settings/work-integrations/$integrationId/logs/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute
    }
    '/(app)/org/$org/settings/work-integrations/$integrationId/issues/': {
      id: '/(app)/org/$org/settings/work-integrations/$integrationId/issues/'
      path: '/issues'
      fullPath: '/org/$org/settings/work-integrations/$integrationId/issues/'
      preLoaderRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users/$userId/': {
      id: '/(app)/org/$org/settings/user-management/users/$userId/'
      path: '/$userId'
      fullPath: '/org/$org/settings/user-management/users/$userId/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRoute
    }
    '/(app)/org/$org/settings/teams/team/$teamId/': {
      id: '/(app)/org/$org/settings/teams/team/$teamId/'
      path: '/'
      fullPath: '/org/$org/settings/teams/team/$teamId/'
      preLoaderRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRoute
    }
    '/(app)/org/$org/settings/notifications/subscriptions/idea-manager/': {
      id: '/(app)/org/$org/settings/notifications/subscriptions/idea-manager/'
      path: '/idea-manager'
      fullPath: '/org/$org/settings/notifications/subscriptions/idea-manager/'
      preLoaderRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRoute
    }
    '/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/': {
      id: '/(app)/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/'
      path: '/workload-scheme/$workloadSchemeId'
      fullPath: '/org/$org/settings/capacity/workload-scheme/$workloadSchemeId/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/': {
      id: '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
      path: '/holiday-scheme/$holidaySchemeId'
      fullPath: '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/strategy/manage/': {
      id: '/(app)/org/$org/loop/$loopId/strategy/manage/'
      path: '/strategy/manage'
      fullPath: '/org/$org/loop/$loopId/strategy/manage/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdStrategyManageIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/portfolio/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/table/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/portfolio/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/swimlane/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/swimlane/'
      path: '/swimlane'
      fullPath: '/org/$org/loop/$loopId/portfolio/swimlane/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/node-graph/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/node-graph/'
      path: '/node-graph'
      fullPath: '/org/$org/loop/$loopId/portfolio/node-graph/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/live/': {
      id: '/(app)/org/$org/loop/$loopId/planner/live/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/planner/live/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerLiveIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerLiveRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/dashboard/deliverables/': {
      id: '/(app)/org/$org/loop/$loopId/dashboard/deliverables/'
      path: '/deliverables'
      fullPath: '/org/$org/loop/$loopId/dashboard/deliverables/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdDashboardRouteRoute
    }
    '/(app)/org/$org/intake/portals/$portalId/$formId/': {
      id: '/(app)/org/$org/intake/portals/$portalId/$formId/'
      path: '/$portalId/$formId'
      fullPath: '/org/$org/intake/portals/$portalId/$formId/'
      preLoaderRoute: typeof appOrgOrgIntakePortalsPortalIdFormIdIndexRouteImport
      parentRoute: typeof appOrgOrgIntakePortalsRouteRoute
    }
    '/(app)/org/$org/intake/ideas/view/$viewId/': {
      id: '/(app)/org/$org/intake/ideas/view/$viewId/'
      path: '/ideas/view/$viewId'
      fullPath: '/org/$org/intake/ideas/view/$viewId/'
      preLoaderRoute: typeof appOrgOrgIntakeIdeasViewViewIdIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId'
      path: '/view/$viewId'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId'
      path: '/view/$viewId'
      fullPath: '/org/$org/loop/$loopId/portfolio/view/$viewId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId'
      path: '/scenario/$scenarioId'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/table/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/swimlane/'
      path: '/swimlane'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/swimlane/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/main/node-graph/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/main/node-graph/'
      path: '/node-graph'
      fullPath: '/org/$org/loop/$loopId/visualizations/main/node-graph/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/portfolio/view/$viewId/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/'
      path: '/'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/live/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/planner/live/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/planner/live/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerLiveRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/live/table/': {
      id: '/(app)/org/$org/loop/$loopId/planner/live/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/planner/live/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerLiveTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerLiveRouteRoute
    }
    '/(app)/org/$org/intake/demands/views/view/$viewId/': {
      id: '/(app)/org/$org/intake/demands/views/view/$viewId/'
      path: '/demands/views/view/$viewId'
      fullPath: '/org/$org/intake/demands/views/view/$viewId/'
      preLoaderRoute: typeof appOrgOrgIntakeDemandsViewsViewViewIdIndexRouteImport
      parentRoute: typeof appOrgOrgIntakeRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/'
      path: '/swimlane'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph/': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph/'
      path: '/node-graph'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/node-graph/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/portfolio/view/$viewId/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/table/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/portfolio/view/$viewId/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane/'
      path: '/swimlane'
      fullPath: '/org/$org/loop/$loopId/portfolio/view/$viewId/swimlane/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/': {
      id: '/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/'
      path: '/node-graph'
      fullPath: '/org/$org/loop/$loopId/portfolio/view/$viewId/node-graph/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId/timeline/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/'
      path: '/table'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId/table/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/': {
      id: '/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/'
      path: '/overview'
      fullPath: '/org/$org/loop/$loopId/planner/scenario/$scenarioId/overview/'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/png'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/pdf'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/svg'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/png'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf': {
      id: '/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
      path: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
      fullPath: '/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/swimlane/pdf'
      preLoaderRoute: typeof unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
      path: '/timeline/preview/$visualizationId'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
    '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId': {
      id: '/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
      path: '/swimlane/preview/$visualizationId'
      fullPath: '/org/$org/loop/$loopId/visualizations/view/$viewId/swimlane/preview/$visualizationId'
      preLoaderRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRouteImport
      parentRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute
    }
  }
}

interface appOrgOrgIntakeInboxRouteRouteChildren {
  appOrgOrgIntakeInboxIndexRoute: typeof appOrgOrgIntakeInboxIndexRoute
}

const appOrgOrgIntakeInboxRouteRouteChildren: appOrgOrgIntakeInboxRouteRouteChildren =
  {
    appOrgOrgIntakeInboxIndexRoute: appOrgOrgIntakeInboxIndexRoute,
  }

const appOrgOrgIntakeInboxRouteRouteWithChildren =
  appOrgOrgIntakeInboxRouteRoute._addFileChildren(
    appOrgOrgIntakeInboxRouteRouteChildren,
  )

interface appOrgOrgIntakePortalsRouteRouteChildren {
  appOrgOrgIntakePortalsIndexRoute: typeof appOrgOrgIntakePortalsIndexRoute
  appOrgOrgIntakePortalsPortalIdIndexRoute: typeof appOrgOrgIntakePortalsPortalIdIndexRoute
  appOrgOrgIntakePortalsCreateIndexRoute: typeof appOrgOrgIntakePortalsCreateIndexRoute
  appOrgOrgIntakePortalsPortalIdFormIdIndexRoute: typeof appOrgOrgIntakePortalsPortalIdFormIdIndexRoute
}

const appOrgOrgIntakePortalsRouteRouteChildren: appOrgOrgIntakePortalsRouteRouteChildren =
  {
    appOrgOrgIntakePortalsIndexRoute: appOrgOrgIntakePortalsIndexRoute,
    appOrgOrgIntakePortalsPortalIdIndexRoute:
      appOrgOrgIntakePortalsPortalIdIndexRoute,
    appOrgOrgIntakePortalsCreateIndexRoute:
      appOrgOrgIntakePortalsCreateIndexRoute,
    appOrgOrgIntakePortalsPortalIdFormIdIndexRoute:
      appOrgOrgIntakePortalsPortalIdFormIdIndexRoute,
  }

const appOrgOrgIntakePortalsRouteRouteWithChildren =
  appOrgOrgIntakePortalsRouteRoute._addFileChildren(
    appOrgOrgIntakePortalsRouteRouteChildren,
  )

interface appOrgOrgIntakeRouteRouteChildren {
  appOrgOrgIntakeInboxRouteRoute: typeof appOrgOrgIntakeInboxRouteRouteWithChildren
  appOrgOrgIntakePortalsRouteRoute: typeof appOrgOrgIntakePortalsRouteRouteWithChildren
  appOrgOrgIntakeCustomFieldsRoute: typeof appOrgOrgIntakeCustomFieldsRoute
  appOrgOrgIntakeOverviewRoute: typeof appOrgOrgIntakeOverviewRoute
  appOrgOrgIntakePriorityFrameworksRoute: typeof appOrgOrgIntakePriorityFrameworksRoute
  appOrgOrgIntakeIndexRoute: typeof appOrgOrgIntakeIndexRoute
  appOrgOrgIntakeCustomersIndexRoute: typeof appOrgOrgIntakeCustomersIndexRoute
  appOrgOrgIntakeDemandsIndexRoute: typeof appOrgOrgIntakeDemandsIndexRoute
  appOrgOrgIntakeIdeasIndexRoute: typeof appOrgOrgIntakeIdeasIndexRoute
  appOrgOrgIntakeProductAreasIndexRoute: typeof appOrgOrgIntakeProductAreasIndexRoute
  appOrgOrgIntakeDemandsStatusesIndexRoute: typeof appOrgOrgIntakeDemandsStatusesIndexRoute
  appOrgOrgIntakeDemandsViewsIndexRoute: typeof appOrgOrgIntakeDemandsViewsIndexRoute
  appOrgOrgIntakeIdeasAllIndexRoute: typeof appOrgOrgIntakeIdeasAllIndexRoute
  appOrgOrgIntakeIdeasCompletedIndexRoute: typeof appOrgOrgIntakeIdeasCompletedIndexRoute
  appOrgOrgIntakeIdeasCreateIndexRoute: typeof appOrgOrgIntakeIdeasCreateIndexRoute
  appOrgOrgIntakeIdeasViewIndexRoute: typeof appOrgOrgIntakeIdeasViewIndexRoute
  appOrgOrgIntakeProductAreasProductAreaIdIndexRoute: typeof appOrgOrgIntakeProductAreasProductAreaIdIndexRoute
  appOrgOrgIntakeProductAreasCreateIndexRoute: typeof appOrgOrgIntakeProductAreasCreateIndexRoute
  appOrgOrgIntakeIdeasViewViewIdIndexRoute: typeof appOrgOrgIntakeIdeasViewViewIdIndexRoute
  appOrgOrgIntakeDemandsViewsViewViewIdIndexRoute: typeof appOrgOrgIntakeDemandsViewsViewViewIdIndexRoute
}

const appOrgOrgIntakeRouteRouteChildren: appOrgOrgIntakeRouteRouteChildren = {
  appOrgOrgIntakeInboxRouteRoute: appOrgOrgIntakeInboxRouteRouteWithChildren,
  appOrgOrgIntakePortalsRouteRoute:
    appOrgOrgIntakePortalsRouteRouteWithChildren,
  appOrgOrgIntakeCustomFieldsRoute: appOrgOrgIntakeCustomFieldsRoute,
  appOrgOrgIntakeOverviewRoute: appOrgOrgIntakeOverviewRoute,
  appOrgOrgIntakePriorityFrameworksRoute:
    appOrgOrgIntakePriorityFrameworksRoute,
  appOrgOrgIntakeIndexRoute: appOrgOrgIntakeIndexRoute,
  appOrgOrgIntakeCustomersIndexRoute: appOrgOrgIntakeCustomersIndexRoute,
  appOrgOrgIntakeDemandsIndexRoute: appOrgOrgIntakeDemandsIndexRoute,
  appOrgOrgIntakeIdeasIndexRoute: appOrgOrgIntakeIdeasIndexRoute,
  appOrgOrgIntakeProductAreasIndexRoute: appOrgOrgIntakeProductAreasIndexRoute,
  appOrgOrgIntakeDemandsStatusesIndexRoute:
    appOrgOrgIntakeDemandsStatusesIndexRoute,
  appOrgOrgIntakeDemandsViewsIndexRoute: appOrgOrgIntakeDemandsViewsIndexRoute,
  appOrgOrgIntakeIdeasAllIndexRoute: appOrgOrgIntakeIdeasAllIndexRoute,
  appOrgOrgIntakeIdeasCompletedIndexRoute:
    appOrgOrgIntakeIdeasCompletedIndexRoute,
  appOrgOrgIntakeIdeasCreateIndexRoute: appOrgOrgIntakeIdeasCreateIndexRoute,
  appOrgOrgIntakeIdeasViewIndexRoute: appOrgOrgIntakeIdeasViewIndexRoute,
  appOrgOrgIntakeProductAreasProductAreaIdIndexRoute:
    appOrgOrgIntakeProductAreasProductAreaIdIndexRoute,
  appOrgOrgIntakeProductAreasCreateIndexRoute:
    appOrgOrgIntakeProductAreasCreateIndexRoute,
  appOrgOrgIntakeIdeasViewViewIdIndexRoute:
    appOrgOrgIntakeIdeasViewViewIdIndexRoute,
  appOrgOrgIntakeDemandsViewsViewViewIdIndexRoute:
    appOrgOrgIntakeDemandsViewsViewViewIdIndexRoute,
}

const appOrgOrgIntakeRouteRouteWithChildren =
  appOrgOrgIntakeRouteRoute._addFileChildren(appOrgOrgIntakeRouteRouteChildren)

interface appOrgOrgLoopLoopIdDashboardRouteRouteChildren {
  appOrgOrgLoopLoopIdDashboardIndexRoute: typeof appOrgOrgLoopLoopIdDashboardIndexRoute
  appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute: typeof appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute
}

const appOrgOrgLoopLoopIdDashboardRouteRouteChildren: appOrgOrgLoopLoopIdDashboardRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdDashboardIndexRoute:
      appOrgOrgLoopLoopIdDashboardIndexRoute,
    appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute:
      appOrgOrgLoopLoopIdDashboardDeliverablesIndexRoute,
  }

const appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren =
  appOrgOrgLoopLoopIdDashboardRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdDashboardRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPlannerLiveRouteRouteChildren {
  appOrgOrgLoopLoopIdPlannerLiveIndexRoute: typeof appOrgOrgLoopLoopIdPlannerLiveIndexRoute
  appOrgOrgLoopLoopIdPlannerLiveTableIndexRoute: typeof appOrgOrgLoopLoopIdPlannerLiveTableIndexRoute
  appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRoute: typeof appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRoute
}

const appOrgOrgLoopLoopIdPlannerLiveRouteRouteChildren: appOrgOrgLoopLoopIdPlannerLiveRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPlannerLiveIndexRoute:
      appOrgOrgLoopLoopIdPlannerLiveIndexRoute,
    appOrgOrgLoopLoopIdPlannerLiveTableIndexRoute:
      appOrgOrgLoopLoopIdPlannerLiveTableIndexRoute,
    appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRoute:
      appOrgOrgLoopLoopIdPlannerLiveTimelineIndexRoute,
  }

const appOrgOrgLoopLoopIdPlannerLiveRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPlannerLiveRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPlannerLiveRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteChildren {
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRoute
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute
}

const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteChildren: appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdIndexRoute,
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdOverviewIndexRoute,
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTableIndexRoute,
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdTimelineIndexRoute,
  }

const appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPlannerRouteRouteChildren {
  appOrgOrgLoopLoopIdPlannerLiveRouteRoute: typeof appOrgOrgLoopLoopIdPlannerLiveRouteRouteWithChildren
  appOrgOrgLoopLoopIdPlannerIndexRoute: typeof appOrgOrgLoopLoopIdPlannerIndexRoute
  appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute: typeof appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren
}

const appOrgOrgLoopLoopIdPlannerRouteRouteChildren: appOrgOrgLoopLoopIdPlannerRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPlannerLiveRouteRoute:
      appOrgOrgLoopLoopIdPlannerLiveRouteRouteWithChildren,
    appOrgOrgLoopLoopIdPlannerIndexRoute: appOrgOrgLoopLoopIdPlannerIndexRoute,
    appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRoute:
      appOrgOrgLoopLoopIdPlannerScenarioScenarioIdRouteRouteWithChildren,
  }

const appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPlannerRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPlannerRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteChildren {
  appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRoute
  appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRoute
  appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRoute
  appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRoute
  appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRoute
}

const appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteChildren: appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRoute:
      appOrgOrgLoopLoopIdPortfolioViewViewIdIndexRoute,
    appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRoute:
      appOrgOrgLoopLoopIdPortfolioViewViewIdNodeGraphIndexRoute,
    appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRoute:
      appOrgOrgLoopLoopIdPortfolioViewViewIdSwimlaneIndexRoute,
    appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRoute:
      appOrgOrgLoopLoopIdPortfolioViewViewIdTableIndexRoute,
    appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRoute:
      appOrgOrgLoopLoopIdPortfolioViewViewIdTimelineIndexRoute,
  }

const appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdPortfolioRouteRouteChildren {
  appOrgOrgLoopLoopIdPortfolioIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioIndexRoute
  appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute: typeof appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteWithChildren
  appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRoute
  appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRoute
  appOrgOrgLoopLoopIdPortfolioTableIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioTableIndexRoute
  appOrgOrgLoopLoopIdPortfolioTimelineIndexRoute: typeof appOrgOrgLoopLoopIdPortfolioTimelineIndexRoute
}

const appOrgOrgLoopLoopIdPortfolioRouteRouteChildren: appOrgOrgLoopLoopIdPortfolioRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdPortfolioIndexRoute:
      appOrgOrgLoopLoopIdPortfolioIndexRoute,
    appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRoute:
      appOrgOrgLoopLoopIdPortfolioViewViewIdRouteRouteWithChildren,
    appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRoute:
      appOrgOrgLoopLoopIdPortfolioNodeGraphIndexRoute,
    appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRoute:
      appOrgOrgLoopLoopIdPortfolioSwimlaneIndexRoute,
    appOrgOrgLoopLoopIdPortfolioTableIndexRoute:
      appOrgOrgLoopLoopIdPortfolioTableIndexRoute,
    appOrgOrgLoopLoopIdPortfolioTimelineIndexRoute:
      appOrgOrgLoopLoopIdPortfolioTimelineIndexRoute,
  }

const appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren =
  appOrgOrgLoopLoopIdPortfolioRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdPortfolioRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdTeamsRouteRouteChildren {
  appOrgOrgLoopLoopIdTeamsIndexRoute: typeof appOrgOrgLoopLoopIdTeamsIndexRoute
}

const appOrgOrgLoopLoopIdTeamsRouteRouteChildren: appOrgOrgLoopLoopIdTeamsRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdTeamsIndexRoute: appOrgOrgLoopLoopIdTeamsIndexRoute,
  }

const appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren =
  appOrgOrgLoopLoopIdTeamsRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdTeamsRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdVisualizationsMainRouteRouteChildren {
  appOrgOrgLoopLoopIdVisualizationsMainIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainIndexRoute
  appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRoute
  appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute
  appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute
  appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute
}

const appOrgOrgLoopLoopIdVisualizationsMainRouteRouteChildren: appOrgOrgLoopLoopIdVisualizationsMainRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdVisualizationsMainIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainNodeGraphIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainSwimlaneIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainTableIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsMainTimelineIndexRoute,
  }

const appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren =
  appOrgOrgLoopLoopIdVisualizationsMainRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdVisualizationsMainRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteChildren {
  appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute
}

const appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteChildren: appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdNodeGraphIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlaneIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdTableIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelineIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdSwimlanePreviewVisualizationIdRouteRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdTimelinePreviewVisualizationIdRouteRoute,
  }

const appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren =
  appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdVisualizationsRouteRouteChildren {
  appOrgOrgLoopLoopIdVisualizationsMainRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren
  appOrgOrgLoopLoopIdVisualizationsIndexRoute: typeof appOrgOrgLoopLoopIdVisualizationsIndexRoute
  appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren
}

const appOrgOrgLoopLoopIdVisualizationsRouteRouteChildren: appOrgOrgLoopLoopIdVisualizationsRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdVisualizationsMainRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsMainRouteRouteWithChildren,
    appOrgOrgLoopLoopIdVisualizationsIndexRoute:
      appOrgOrgLoopLoopIdVisualizationsIndexRoute,
    appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsViewViewIdRouteRouteWithChildren,
  }

const appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren =
  appOrgOrgLoopLoopIdVisualizationsRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdVisualizationsRouteRouteChildren,
  )

interface appOrgOrgLoopLoopIdRouteRouteChildren {
  appOrgOrgLoopLoopIdDashboardRouteRoute: typeof appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren
  appOrgOrgLoopLoopIdPlannerRouteRoute: typeof appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren
  appOrgOrgLoopLoopIdPortfolioRouteRoute: typeof appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren
  appOrgOrgLoopLoopIdTeamsRouteRoute: typeof appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren
  appOrgOrgLoopLoopIdVisualizationsRouteRoute: typeof appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren
  appOrgOrgLoopLoopIdIndexRoute: typeof appOrgOrgLoopLoopIdIndexRoute
  appOrgOrgLoopLoopIdFinancialsIndexRoute: typeof appOrgOrgLoopLoopIdFinancialsIndexRoute
  appOrgOrgLoopLoopIdIntegrationsIndexRoute: typeof appOrgOrgLoopLoopIdIntegrationsIndexRoute
  appOrgOrgLoopLoopIdIntelligenceIndexRoute: typeof appOrgOrgLoopLoopIdIntelligenceIndexRoute
  appOrgOrgLoopLoopIdLoopIntelligenceIndexRoute: typeof appOrgOrgLoopLoopIdLoopIntelligenceIndexRoute
  appOrgOrgLoopLoopIdOverviewIndexRoute: typeof appOrgOrgLoopLoopIdOverviewIndexRoute
  appOrgOrgLoopLoopIdStrategyIndexRoute: typeof appOrgOrgLoopLoopIdStrategyIndexRoute
  appOrgOrgLoopLoopIdStrategyManageIndexRoute: typeof appOrgOrgLoopLoopIdStrategyManageIndexRoute
}

const appOrgOrgLoopLoopIdRouteRouteChildren: appOrgOrgLoopLoopIdRouteRouteChildren =
  {
    appOrgOrgLoopLoopIdDashboardRouteRoute:
      appOrgOrgLoopLoopIdDashboardRouteRouteWithChildren,
    appOrgOrgLoopLoopIdPlannerRouteRoute:
      appOrgOrgLoopLoopIdPlannerRouteRouteWithChildren,
    appOrgOrgLoopLoopIdPortfolioRouteRoute:
      appOrgOrgLoopLoopIdPortfolioRouteRouteWithChildren,
    appOrgOrgLoopLoopIdTeamsRouteRoute:
      appOrgOrgLoopLoopIdTeamsRouteRouteWithChildren,
    appOrgOrgLoopLoopIdVisualizationsRouteRoute:
      appOrgOrgLoopLoopIdVisualizationsRouteRouteWithChildren,
    appOrgOrgLoopLoopIdIndexRoute: appOrgOrgLoopLoopIdIndexRoute,
    appOrgOrgLoopLoopIdFinancialsIndexRoute:
      appOrgOrgLoopLoopIdFinancialsIndexRoute,
    appOrgOrgLoopLoopIdIntegrationsIndexRoute:
      appOrgOrgLoopLoopIdIntegrationsIndexRoute,
    appOrgOrgLoopLoopIdIntelligenceIndexRoute:
      appOrgOrgLoopLoopIdIntelligenceIndexRoute,
    appOrgOrgLoopLoopIdLoopIntelligenceIndexRoute:
      appOrgOrgLoopLoopIdLoopIntelligenceIndexRoute,
    appOrgOrgLoopLoopIdOverviewIndexRoute:
      appOrgOrgLoopLoopIdOverviewIndexRoute,
    appOrgOrgLoopLoopIdStrategyIndexRoute:
      appOrgOrgLoopLoopIdStrategyIndexRoute,
    appOrgOrgLoopLoopIdStrategyManageIndexRoute:
      appOrgOrgLoopLoopIdStrategyManageIndexRoute,
  }

const appOrgOrgLoopLoopIdRouteRouteWithChildren =
  appOrgOrgLoopLoopIdRouteRoute._addFileChildren(
    appOrgOrgLoopLoopIdRouteRouteChildren,
  )

interface appOrgOrgLoopRouteRouteChildren {
  appOrgOrgLoopLoopIdRouteRoute: typeof appOrgOrgLoopLoopIdRouteRouteWithChildren
}

const appOrgOrgLoopRouteRouteChildren: appOrgOrgLoopRouteRouteChildren = {
  appOrgOrgLoopLoopIdRouteRoute: appOrgOrgLoopLoopIdRouteRouteWithChildren,
}

const appOrgOrgLoopRouteRouteWithChildren =
  appOrgOrgLoopRouteRoute._addFileChildren(appOrgOrgLoopRouteRouteChildren)

interface appOrgOrgLoopIntelligenceRouteRouteChildren {
  appOrgOrgLoopIntelligenceIndexRoute: typeof appOrgOrgLoopIntelligenceIndexRoute
}

const appOrgOrgLoopIntelligenceRouteRouteChildren: appOrgOrgLoopIntelligenceRouteRouteChildren =
  {
    appOrgOrgLoopIntelligenceIndexRoute: appOrgOrgLoopIntelligenceIndexRoute,
  }

const appOrgOrgLoopIntelligenceRouteRouteWithChildren =
  appOrgOrgLoopIntelligenceRouteRoute._addFileChildren(
    appOrgOrgLoopIntelligenceRouteRouteChildren,
  )

interface appOrgOrgSettingsCapacityRouteRouteChildren {
  appOrgOrgSettingsCapacityIndexRoute: typeof appOrgOrgSettingsCapacityIndexRoute
  appOrgOrgSettingsCapacityHolidaySchemeIndexRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRoute
  appOrgOrgSettingsCapacityOrphanedDataIndexRoute: typeof appOrgOrgSettingsCapacityOrphanedDataIndexRoute
  appOrgOrgSettingsCapacityWorkloadSchemeIndexRoute: typeof appOrgOrgSettingsCapacityWorkloadSchemeIndexRoute
  appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute: typeof appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute
}

const appOrgOrgSettingsCapacityRouteRouteChildren: appOrgOrgSettingsCapacityRouteRouteChildren =
  {
    appOrgOrgSettingsCapacityIndexRoute: appOrgOrgSettingsCapacityIndexRoute,
    appOrgOrgSettingsCapacityHolidaySchemeIndexRoute:
      appOrgOrgSettingsCapacityHolidaySchemeIndexRoute,
    appOrgOrgSettingsCapacityOrphanedDataIndexRoute:
      appOrgOrgSettingsCapacityOrphanedDataIndexRoute,
    appOrgOrgSettingsCapacityWorkloadSchemeIndexRoute:
      appOrgOrgSettingsCapacityWorkloadSchemeIndexRoute,
    appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute:
      appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute,
    appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute:
      appOrgOrgSettingsCapacityWorkloadSchemeWorkloadSchemeIdIndexRoute,
  }

const appOrgOrgSettingsCapacityRouteRouteWithChildren =
  appOrgOrgSettingsCapacityRouteRoute._addFileChildren(
    appOrgOrgSettingsCapacityRouteRouteChildren,
  )

interface appOrgOrgSettingsConnectionsRouteRouteChildren {
  appOrgOrgSettingsConnectionsIndexRoute: typeof appOrgOrgSettingsConnectionsIndexRoute
}

const appOrgOrgSettingsConnectionsRouteRouteChildren: appOrgOrgSettingsConnectionsRouteRouteChildren =
  {
    appOrgOrgSettingsConnectionsIndexRoute:
      appOrgOrgSettingsConnectionsIndexRoute,
  }

const appOrgOrgSettingsConnectionsRouteRouteWithChildren =
  appOrgOrgSettingsConnectionsRouteRoute._addFileChildren(
    appOrgOrgSettingsConnectionsRouteRouteChildren,
  )

interface appOrgOrgSettingsCreditsRouteRouteChildren {
  appOrgOrgSettingsCreditsIndexRoute: typeof appOrgOrgSettingsCreditsIndexRoute
}

const appOrgOrgSettingsCreditsRouteRouteChildren: appOrgOrgSettingsCreditsRouteRouteChildren =
  {
    appOrgOrgSettingsCreditsIndexRoute: appOrgOrgSettingsCreditsIndexRoute,
  }

const appOrgOrgSettingsCreditsRouteRouteWithChildren =
  appOrgOrgSettingsCreditsRouteRoute._addFileChildren(
    appOrgOrgSettingsCreditsRouteRouteChildren,
  )

interface appOrgOrgSettingsCurrencyRouteRouteChildren {
  appOrgOrgSettingsCurrencyIndexRoute: typeof appOrgOrgSettingsCurrencyIndexRoute
}

const appOrgOrgSettingsCurrencyRouteRouteChildren: appOrgOrgSettingsCurrencyRouteRouteChildren =
  {
    appOrgOrgSettingsCurrencyIndexRoute: appOrgOrgSettingsCurrencyIndexRoute,
  }

const appOrgOrgSettingsCurrencyRouteRouteWithChildren =
  appOrgOrgSettingsCurrencyRouteRoute._addFileChildren(
    appOrgOrgSettingsCurrencyRouteRouteChildren,
  )

interface appOrgOrgSettingsDomainsRouteRouteChildren {
  appOrgOrgSettingsDomainsIndexRoute: typeof appOrgOrgSettingsDomainsIndexRoute
}

const appOrgOrgSettingsDomainsRouteRouteChildren: appOrgOrgSettingsDomainsRouteRouteChildren =
  {
    appOrgOrgSettingsDomainsIndexRoute: appOrgOrgSettingsDomainsIndexRoute,
  }

const appOrgOrgSettingsDomainsRouteRouteWithChildren =
  appOrgOrgSettingsDomainsRouteRoute._addFileChildren(
    appOrgOrgSettingsDomainsRouteRouteChildren,
  )

interface appOrgOrgSettingsLocationRouteRouteChildren {
  appOrgOrgSettingsLocationIndexRoute: typeof appOrgOrgSettingsLocationIndexRoute
}

const appOrgOrgSettingsLocationRouteRouteChildren: appOrgOrgSettingsLocationRouteRouteChildren =
  {
    appOrgOrgSettingsLocationIndexRoute: appOrgOrgSettingsLocationIndexRoute,
  }

const appOrgOrgSettingsLocationRouteRouteWithChildren =
  appOrgOrgSettingsLocationRouteRoute._addFileChildren(
    appOrgOrgSettingsLocationRouteRouteChildren,
  )

interface appOrgOrgSettingsOauthClientsRouteRouteChildren {
  appOrgOrgSettingsOauthClientsIdRoute: typeof appOrgOrgSettingsOauthClientsIdRoute
  appOrgOrgSettingsOauthClientsIndexRoute: typeof appOrgOrgSettingsOauthClientsIndexRoute
}

const appOrgOrgSettingsOauthClientsRouteRouteChildren: appOrgOrgSettingsOauthClientsRouteRouteChildren =
  {
    appOrgOrgSettingsOauthClientsIdRoute: appOrgOrgSettingsOauthClientsIdRoute,
    appOrgOrgSettingsOauthClientsIndexRoute:
      appOrgOrgSettingsOauthClientsIndexRoute,
  }

const appOrgOrgSettingsOauthClientsRouteRouteWithChildren =
  appOrgOrgSettingsOauthClientsRouteRoute._addFileChildren(
    appOrgOrgSettingsOauthClientsRouteRouteChildren,
  )

interface appOrgOrgSettingsOpenPositionsRouteRouteChildren {
  appOrgOrgSettingsOpenPositionsHiredRoute: typeof appOrgOrgSettingsOpenPositionsHiredRoute
  appOrgOrgSettingsOpenPositionsIndexRoute: typeof appOrgOrgSettingsOpenPositionsIndexRoute
}

const appOrgOrgSettingsOpenPositionsRouteRouteChildren: appOrgOrgSettingsOpenPositionsRouteRouteChildren =
  {
    appOrgOrgSettingsOpenPositionsHiredRoute:
      appOrgOrgSettingsOpenPositionsHiredRoute,
    appOrgOrgSettingsOpenPositionsIndexRoute:
      appOrgOrgSettingsOpenPositionsIndexRoute,
  }

const appOrgOrgSettingsOpenPositionsRouteRouteWithChildren =
  appOrgOrgSettingsOpenPositionsRouteRoute._addFileChildren(
    appOrgOrgSettingsOpenPositionsRouteRouteChildren,
  )

interface appOrgOrgSettingsOrganizationRouteRouteChildren {
  appOrgOrgSettingsOrganizationIndexRoute: typeof appOrgOrgSettingsOrganizationIndexRoute
}

const appOrgOrgSettingsOrganizationRouteRouteChildren: appOrgOrgSettingsOrganizationRouteRouteChildren =
  {
    appOrgOrgSettingsOrganizationIndexRoute:
      appOrgOrgSettingsOrganizationIndexRoute,
  }

const appOrgOrgSettingsOrganizationRouteRouteWithChildren =
  appOrgOrgSettingsOrganizationRouteRoute._addFileChildren(
    appOrgOrgSettingsOrganizationRouteRouteChildren,
  )

interface appOrgOrgSettingsPeopleRouteRouteChildren {
  appOrgOrgSettingsPeopleIndexRoute: typeof appOrgOrgSettingsPeopleIndexRoute
}

const appOrgOrgSettingsPeopleRouteRouteChildren: appOrgOrgSettingsPeopleRouteRouteChildren =
  {
    appOrgOrgSettingsPeopleIndexRoute: appOrgOrgSettingsPeopleIndexRoute,
  }

const appOrgOrgSettingsPeopleRouteRouteWithChildren =
  appOrgOrgSettingsPeopleRouteRoute._addFileChildren(
    appOrgOrgSettingsPeopleRouteRouteChildren,
  )

interface appOrgOrgSettingsRolesRouteRouteChildren {
  appOrgOrgSettingsRolesIndexRoute: typeof appOrgOrgSettingsRolesIndexRoute
}

const appOrgOrgSettingsRolesRouteRouteChildren: appOrgOrgSettingsRolesRouteRouteChildren =
  {
    appOrgOrgSettingsRolesIndexRoute: appOrgOrgSettingsRolesIndexRoute,
  }

const appOrgOrgSettingsRolesRouteRouteWithChildren =
  appOrgOrgSettingsRolesRouteRoute._addFileChildren(
    appOrgOrgSettingsRolesRouteRouteChildren,
  )

interface appOrgOrgSettingsSkillsRouteRouteChildren {
  appOrgOrgSettingsSkillsIndexRoute: typeof appOrgOrgSettingsSkillsIndexRoute
}

const appOrgOrgSettingsSkillsRouteRouteChildren: appOrgOrgSettingsSkillsRouteRouteChildren =
  {
    appOrgOrgSettingsSkillsIndexRoute: appOrgOrgSettingsSkillsIndexRoute,
  }

const appOrgOrgSettingsSkillsRouteRouteWithChildren =
  appOrgOrgSettingsSkillsRouteRoute._addFileChildren(
    appOrgOrgSettingsSkillsRouteRouteChildren,
  )

interface appOrgOrgSettingsSubscriptionsRouteRouteChildren {
  appOrgOrgSettingsSubscriptionsIndexRoute: typeof appOrgOrgSettingsSubscriptionsIndexRoute
}

const appOrgOrgSettingsSubscriptionsRouteRouteChildren: appOrgOrgSettingsSubscriptionsRouteRouteChildren =
  {
    appOrgOrgSettingsSubscriptionsIndexRoute:
      appOrgOrgSettingsSubscriptionsIndexRoute,
  }

const appOrgOrgSettingsSubscriptionsRouteRouteWithChildren =
  appOrgOrgSettingsSubscriptionsRouteRoute._addFileChildren(
    appOrgOrgSettingsSubscriptionsRouteRouteChildren,
  )

interface appOrgOrgSettingsTeamsTeamTeamIdRouteRouteChildren {
  appOrgOrgSettingsTeamsTeamTeamIdIndexRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdIndexRoute
}

const appOrgOrgSettingsTeamsTeamTeamIdRouteRouteChildren: appOrgOrgSettingsTeamsTeamTeamIdRouteRouteChildren =
  {
    appOrgOrgSettingsTeamsTeamTeamIdIndexRoute:
      appOrgOrgSettingsTeamsTeamTeamIdIndexRoute,
  }

const appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren =
  appOrgOrgSettingsTeamsTeamTeamIdRouteRoute._addFileChildren(
    appOrgOrgSettingsTeamsTeamTeamIdRouteRouteChildren,
  )

interface appOrgOrgSettingsTeamsRouteRouteChildren {
  appOrgOrgSettingsTeamsIndexRoute: typeof appOrgOrgSettingsTeamsIndexRoute
  appOrgOrgSettingsTeamsTeamTeamIdRouteRoute: typeof appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren
}

const appOrgOrgSettingsTeamsRouteRouteChildren: appOrgOrgSettingsTeamsRouteRouteChildren =
  {
    appOrgOrgSettingsTeamsIndexRoute: appOrgOrgSettingsTeamsIndexRoute,
    appOrgOrgSettingsTeamsTeamTeamIdRouteRoute:
      appOrgOrgSettingsTeamsTeamTeamIdRouteRouteWithChildren,
  }

const appOrgOrgSettingsTeamsRouteRouteWithChildren =
  appOrgOrgSettingsTeamsRouteRoute._addFileChildren(
    appOrgOrgSettingsTeamsRouteRouteChildren,
  )

interface appOrgOrgSettingsUserManagementUsersRouteRouteChildren {
  appOrgOrgSettingsUserManagementUsersIndexRoute: typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  appOrgOrgSettingsUserManagementUsersUserIdIndexRoute: typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
}

const appOrgOrgSettingsUserManagementUsersRouteRouteChildren: appOrgOrgSettingsUserManagementUsersRouteRouteChildren =
  {
    appOrgOrgSettingsUserManagementUsersIndexRoute:
      appOrgOrgSettingsUserManagementUsersIndexRoute,
    appOrgOrgSettingsUserManagementUsersUserIdIndexRoute:
      appOrgOrgSettingsUserManagementUsersUserIdIndexRoute,
  }

const appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren =
  appOrgOrgSettingsUserManagementUsersRouteRoute._addFileChildren(
    appOrgOrgSettingsUserManagementUsersRouteRouteChildren,
  )

interface appOrgOrgSettingsUserManagementRouteRouteChildren {
  appOrgOrgSettingsUserManagementUsersRouteRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  appOrgOrgSettingsUserManagementIndexRoute: typeof appOrgOrgSettingsUserManagementIndexRoute
  appOrgOrgSettingsUserManagementInvitesIndexRoute: typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
}

const appOrgOrgSettingsUserManagementRouteRouteChildren: appOrgOrgSettingsUserManagementRouteRouteChildren =
  {
    appOrgOrgSettingsUserManagementUsersRouteRoute:
      appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren,
    appOrgOrgSettingsUserManagementIndexRoute:
      appOrgOrgSettingsUserManagementIndexRoute,
    appOrgOrgSettingsUserManagementInvitesIndexRoute:
      appOrgOrgSettingsUserManagementInvitesIndexRoute,
  }

const appOrgOrgSettingsUserManagementRouteRouteWithChildren =
  appOrgOrgSettingsUserManagementRouteRoute._addFileChildren(
    appOrgOrgSettingsUserManagementRouteRouteChildren,
  )

interface appOrgOrgSettingsWorkItemUsageRouteRouteChildren {
  appOrgOrgSettingsWorkItemUsageIndexRoute: typeof appOrgOrgSettingsWorkItemUsageIndexRoute
}

const appOrgOrgSettingsWorkItemUsageRouteRouteChildren: appOrgOrgSettingsWorkItemUsageRouteRouteChildren =
  {
    appOrgOrgSettingsWorkItemUsageIndexRoute:
      appOrgOrgSettingsWorkItemUsageIndexRoute,
  }

const appOrgOrgSettingsWorkItemUsageRouteRouteWithChildren =
  appOrgOrgSettingsWorkItemUsageRouteRoute._addFileChildren(
    appOrgOrgSettingsWorkItemUsageRouteRouteChildren,
  )

interface appOrgOrgSettingsNotificationsSubscriptionsRouteRouteChildren {
  appOrgOrgSettingsNotificationsSubscriptionsIndexRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsIndexRoute
  appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute
}

const appOrgOrgSettingsNotificationsSubscriptionsRouteRouteChildren: appOrgOrgSettingsNotificationsSubscriptionsRouteRouteChildren =
  {
    appOrgOrgSettingsNotificationsSubscriptionsIndexRoute:
      appOrgOrgSettingsNotificationsSubscriptionsIndexRoute,
    appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute:
      appOrgOrgSettingsNotificationsSubscriptionsIdeaManagerIndexRoute,
  }

const appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren =
  appOrgOrgSettingsNotificationsSubscriptionsRouteRoute._addFileChildren(
    appOrgOrgSettingsNotificationsSubscriptionsRouteRouteChildren,
  )

interface appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteChildren {
  appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute
  appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute
  appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute
}

const appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteChildren: appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteChildren =
  {
    appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute:
      appOrgOrgSettingsWorkIntegrationsIntegrationIdIndexRoute,
    appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute:
      appOrgOrgSettingsWorkIntegrationsIntegrationIdIssuesIndexRoute,
    appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute:
      appOrgOrgSettingsWorkIntegrationsIntegrationIdLogsIndexRoute,
  }

const appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren =
  appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute._addFileChildren(
    appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteChildren,
  )

interface appOrgOrgSettingsRouteRouteChildren {
  appOrgOrgSettingsCapacityRouteRoute: typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  appOrgOrgSettingsConnectionsRouteRoute: typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  appOrgOrgSettingsCreditsRouteRoute: typeof appOrgOrgSettingsCreditsRouteRouteWithChildren
  appOrgOrgSettingsCurrencyRouteRoute: typeof appOrgOrgSettingsCurrencyRouteRouteWithChildren
  appOrgOrgSettingsDomainsRouteRoute: typeof appOrgOrgSettingsDomainsRouteRouteWithChildren
  appOrgOrgSettingsLocationRouteRoute: typeof appOrgOrgSettingsLocationRouteRouteWithChildren
  appOrgOrgSettingsOauthClientsRouteRoute: typeof appOrgOrgSettingsOauthClientsRouteRouteWithChildren
  appOrgOrgSettingsOpenPositionsRouteRoute: typeof appOrgOrgSettingsOpenPositionsRouteRouteWithChildren
  appOrgOrgSettingsOrganizationRouteRoute: typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  appOrgOrgSettingsPeopleRouteRoute: typeof appOrgOrgSettingsPeopleRouteRouteWithChildren
  appOrgOrgSettingsRolesRouteRoute: typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  appOrgOrgSettingsSkillsRouteRoute: typeof appOrgOrgSettingsSkillsRouteRouteWithChildren
  appOrgOrgSettingsSubscriptionsRouteRoute: typeof appOrgOrgSettingsSubscriptionsRouteRouteWithChildren
  appOrgOrgSettingsTeamsRouteRoute: typeof appOrgOrgSettingsTeamsRouteRouteWithChildren
  appOrgOrgSettingsUserManagementRouteRoute: typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  appOrgOrgSettingsWorkItemUsageRouteRoute: typeof appOrgOrgSettingsWorkItemUsageRouteRouteWithChildren
  appOrgOrgSettingsIndexRoute: typeof appOrgOrgSettingsIndexRoute
  appOrgOrgSettingsNotificationsSubscriptionsRouteRoute: typeof appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren
  appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute: typeof appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren
  appOrgOrgSettingsNotificationsSlack_app_healthRoute: typeof appOrgOrgSettingsNotificationsSlack_app_healthRoute
  appOrgOrgSettingsAccountingSandboxIndexRoute: typeof appOrgOrgSettingsAccountingSandboxIndexRoute
  appOrgOrgSettingsAuditIndexRoute: typeof appOrgOrgSettingsAuditIndexRoute
  appOrgOrgSettingsCustomFieldsIndexRoute: typeof appOrgOrgSettingsCustomFieldsIndexRoute
  appOrgOrgSettingsCustomItemStatusIndexRoute: typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  appOrgOrgSettingsEffortEstimationIndexRoute: typeof appOrgOrgSettingsEffortEstimationIndexRoute
  appOrgOrgSettingsItemTypesIndexRoute: typeof appOrgOrgSettingsItemTypesIndexRoute
  appOrgOrgSettingsNotificationsIndexRoute: typeof appOrgOrgSettingsNotificationsIndexRoute
  appOrgOrgSettingsWorkIntegrationsIndexRoute: typeof appOrgOrgSettingsWorkIntegrationsIndexRoute
}

const appOrgOrgSettingsRouteRouteChildren: appOrgOrgSettingsRouteRouteChildren =
  {
    appOrgOrgSettingsCapacityRouteRoute:
      appOrgOrgSettingsCapacityRouteRouteWithChildren,
    appOrgOrgSettingsConnectionsRouteRoute:
      appOrgOrgSettingsConnectionsRouteRouteWithChildren,
    appOrgOrgSettingsCreditsRouteRoute:
      appOrgOrgSettingsCreditsRouteRouteWithChildren,
    appOrgOrgSettingsCurrencyRouteRoute:
      appOrgOrgSettingsCurrencyRouteRouteWithChildren,
    appOrgOrgSettingsDomainsRouteRoute:
      appOrgOrgSettingsDomainsRouteRouteWithChildren,
    appOrgOrgSettingsLocationRouteRoute:
      appOrgOrgSettingsLocationRouteRouteWithChildren,
    appOrgOrgSettingsOauthClientsRouteRoute:
      appOrgOrgSettingsOauthClientsRouteRouteWithChildren,
    appOrgOrgSettingsOpenPositionsRouteRoute:
      appOrgOrgSettingsOpenPositionsRouteRouteWithChildren,
    appOrgOrgSettingsOrganizationRouteRoute:
      appOrgOrgSettingsOrganizationRouteRouteWithChildren,
    appOrgOrgSettingsPeopleRouteRoute:
      appOrgOrgSettingsPeopleRouteRouteWithChildren,
    appOrgOrgSettingsRolesRouteRoute:
      appOrgOrgSettingsRolesRouteRouteWithChildren,
    appOrgOrgSettingsSkillsRouteRoute:
      appOrgOrgSettingsSkillsRouteRouteWithChildren,
    appOrgOrgSettingsSubscriptionsRouteRoute:
      appOrgOrgSettingsSubscriptionsRouteRouteWithChildren,
    appOrgOrgSettingsTeamsRouteRoute:
      appOrgOrgSettingsTeamsRouteRouteWithChildren,
    appOrgOrgSettingsUserManagementRouteRoute:
      appOrgOrgSettingsUserManagementRouteRouteWithChildren,
    appOrgOrgSettingsWorkItemUsageRouteRoute:
      appOrgOrgSettingsWorkItemUsageRouteRouteWithChildren,
    appOrgOrgSettingsIndexRoute: appOrgOrgSettingsIndexRoute,
    appOrgOrgSettingsNotificationsSubscriptionsRouteRoute:
      appOrgOrgSettingsNotificationsSubscriptionsRouteRouteWithChildren,
    appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRoute:
      appOrgOrgSettingsWorkIntegrationsIntegrationIdRouteRouteWithChildren,
    appOrgOrgSettingsNotificationsSlack_app_healthRoute:
      appOrgOrgSettingsNotificationsSlack_app_healthRoute,
    appOrgOrgSettingsAccountingSandboxIndexRoute:
      appOrgOrgSettingsAccountingSandboxIndexRoute,
    appOrgOrgSettingsAuditIndexRoute: appOrgOrgSettingsAuditIndexRoute,
    appOrgOrgSettingsCustomFieldsIndexRoute:
      appOrgOrgSettingsCustomFieldsIndexRoute,
    appOrgOrgSettingsCustomItemStatusIndexRoute:
      appOrgOrgSettingsCustomItemStatusIndexRoute,
    appOrgOrgSettingsEffortEstimationIndexRoute:
      appOrgOrgSettingsEffortEstimationIndexRoute,
    appOrgOrgSettingsItemTypesIndexRoute: appOrgOrgSettingsItemTypesIndexRoute,
    appOrgOrgSettingsNotificationsIndexRoute:
      appOrgOrgSettingsNotificationsIndexRoute,
    appOrgOrgSettingsWorkIntegrationsIndexRoute:
      appOrgOrgSettingsWorkIntegrationsIndexRoute,
  }

const appOrgOrgSettingsRouteRouteWithChildren =
  appOrgOrgSettingsRouteRoute._addFileChildren(
    appOrgOrgSettingsRouteRouteChildren,
  )

interface appOrgOrgRouteRouteChildren {
  appOrgOrgIntakeRouteRoute: typeof appOrgOrgIntakeRouteRouteWithChildren
  appOrgOrgLoopRouteRoute: typeof appOrgOrgLoopRouteRouteWithChildren
  appOrgOrgLoopIntelligenceRouteRoute: typeof appOrgOrgLoopIntelligenceRouteRouteWithChildren
  appOrgOrgSettingsRouteRoute: typeof appOrgOrgSettingsRouteRouteWithChildren
  appOrgOrgIndexRoute: typeof appOrgOrgIndexRoute
  appOrgOrgAuditEntityIdRoute: typeof appOrgOrgAuditEntityIdRoute
  appOrgOrgIdeaManagementSplatRoute: typeof appOrgOrgIdeaManagementSplatRoute
  appOrgOrgAllItemsIndexRoute: typeof appOrgOrgAllItemsIndexRoute
  appOrgOrgDashboardsIndexRoute: typeof appOrgOrgDashboardsIndexRoute
  appOrgOrgDemandIndexRoute: typeof appOrgOrgDemandIndexRoute
  appOrgOrgIdeaManagementIndexRoute: typeof appOrgOrgIdeaManagementIndexRoute
  appOrgOrgNotificationsIndexRoute: typeof appOrgOrgNotificationsIndexRoute
  appOrgOrgObjectivesIndexRoute: typeof appOrgOrgObjectivesIndexRoute
  appOrgOrgSirDebugIndexRoute: typeof appOrgOrgSirDebugIndexRoute
  appOrgOrgVisualizationsIndexRoute: typeof appOrgOrgVisualizationsIndexRoute
  appOrgOrgDashboardsDashboardIdIndexRoute: typeof appOrgOrgDashboardsDashboardIdIndexRoute
  appOrgOrgDashboardsGeneratedDashboardIdIndexRoute: typeof appOrgOrgDashboardsGeneratedDashboardIdIndexRoute
}

const appOrgOrgRouteRouteChildren: appOrgOrgRouteRouteChildren = {
  appOrgOrgIntakeRouteRoute: appOrgOrgIntakeRouteRouteWithChildren,
  appOrgOrgLoopRouteRoute: appOrgOrgLoopRouteRouteWithChildren,
  appOrgOrgLoopIntelligenceRouteRoute:
    appOrgOrgLoopIntelligenceRouteRouteWithChildren,
  appOrgOrgSettingsRouteRoute: appOrgOrgSettingsRouteRouteWithChildren,
  appOrgOrgIndexRoute: appOrgOrgIndexRoute,
  appOrgOrgAuditEntityIdRoute: appOrgOrgAuditEntityIdRoute,
  appOrgOrgIdeaManagementSplatRoute: appOrgOrgIdeaManagementSplatRoute,
  appOrgOrgAllItemsIndexRoute: appOrgOrgAllItemsIndexRoute,
  appOrgOrgDashboardsIndexRoute: appOrgOrgDashboardsIndexRoute,
  appOrgOrgDemandIndexRoute: appOrgOrgDemandIndexRoute,
  appOrgOrgIdeaManagementIndexRoute: appOrgOrgIdeaManagementIndexRoute,
  appOrgOrgNotificationsIndexRoute: appOrgOrgNotificationsIndexRoute,
  appOrgOrgObjectivesIndexRoute: appOrgOrgObjectivesIndexRoute,
  appOrgOrgSirDebugIndexRoute: appOrgOrgSirDebugIndexRoute,
  appOrgOrgVisualizationsIndexRoute: appOrgOrgVisualizationsIndexRoute,
  appOrgOrgDashboardsDashboardIdIndexRoute:
    appOrgOrgDashboardsDashboardIdIndexRoute,
  appOrgOrgDashboardsGeneratedDashboardIdIndexRoute:
    appOrgOrgDashboardsGeneratedDashboardIdIndexRoute,
}

const appOrgOrgRouteRouteWithChildren = appOrgOrgRouteRoute._addFileChildren(
  appOrgOrgRouteRouteChildren,
)

interface appRouteRouteChildren {
  appIndexRoute: typeof appIndexRoute
  appOrgOrgRouteRoute: typeof appOrgOrgRouteRouteWithChildren
  appInvitesAutoAcceptRoute: typeof appInvitesAutoAcceptRoute
  appInvitesIndexRoute: typeof appInvitesIndexRoute
  appOrgIndexRoute: typeof appOrgIndexRoute
  appProfileIndexRoute: typeof appProfileIndexRoute
  appIntegrationsProviderCallbackRoute: typeof appIntegrationsProviderCallbackRoute
  appIntegrationsGithubCallbackRoute: typeof appIntegrationsGithubCallbackRoute
  appIntegrationsJiraCallbackRoute: typeof appIntegrationsJiraCallbackRoute
  appIntegrationsSlackCallbackRoute: typeof appIntegrationsSlackCallbackRoute
  appOrgIdOrgIdSplatRoute: typeof appOrgIdOrgIdSplatRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appIndexRoute: appIndexRoute,
  appOrgOrgRouteRoute: appOrgOrgRouteRouteWithChildren,
  appInvitesAutoAcceptRoute: appInvitesAutoAcceptRoute,
  appInvitesIndexRoute: appInvitesIndexRoute,
  appOrgIndexRoute: appOrgIndexRoute,
  appProfileIndexRoute: appProfileIndexRoute,
  appIntegrationsProviderCallbackRoute: appIntegrationsProviderCallbackRoute,
  appIntegrationsGithubCallbackRoute: appIntegrationsGithubCallbackRoute,
  appIntegrationsJiraCallbackRoute: appIntegrationsJiraCallbackRoute,
  appIntegrationsSlackCallbackRoute: appIntegrationsSlackCallbackRoute,
  appOrgIdOrgIdSplatRoute: appOrgIdOrgIdSplatRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface unauthenticatedOrganizationsInvitesRouteRouteChildren {
  unauthenticatedOrganizationsInvitesAcceptRoute: typeof unauthenticatedOrganizationsInvitesAcceptRoute
  unauthenticatedOrganizationsInvitesErrorIndexRoute: typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
}

const unauthenticatedOrganizationsInvitesRouteRouteChildren: unauthenticatedOrganizationsInvitesRouteRouteChildren =
  {
    unauthenticatedOrganizationsInvitesAcceptRoute:
      unauthenticatedOrganizationsInvitesAcceptRoute,
    unauthenticatedOrganizationsInvitesErrorIndexRoute:
      unauthenticatedOrganizationsInvitesErrorIndexRoute,
  }

const unauthenticatedOrganizationsInvitesRouteRouteWithChildren =
  unauthenticatedOrganizationsInvitesRouteRoute._addFileChildren(
    unauthenticatedOrganizationsInvitesRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
  unauthenticatedAuthErrorRoute: unauthenticatedAuthErrorRoute,
  unauthenticatedIdpLoginRoute: unauthenticatedIdpLoginRoute,
  unauthenticatedSignupRoute: unauthenticatedSignupRoute,
  unauthenticatedTermsRoute: unauthenticatedTermsRoute,
  unauthenticatedOrganizationsInvitesRouteRoute:
    unauthenticatedOrganizationsInvitesRouteRouteWithChildren,
  unauthenticatedLinkIdentityCallbackRoute:
    unauthenticatedLinkIdentityCallbackRoute,
  unauthenticatedOrganizationsNotAMemberRoute:
    unauthenticatedOrganizationsNotAMemberRoute,
  unauthenticatedOrganizationsStartRoute:
    unauthenticatedOrganizationsStartRoute,
  unauthenticatedLinkIdentityIndexRoute: unauthenticatedLinkIdentityIndexRoute,
  unauthenticatedLoginIndexRoute: unauthenticatedLoginIndexRoute,
  unauthenticatedOrganizationSelectorIndexRoute:
    unauthenticatedOrganizationSelectorIndexRoute,
  unauthenticatedPublishedV1SwimlaneLinkIdRoute:
    unauthenticatedPublishedV1SwimlaneLinkIdRoute,
  unauthenticatedPublishedV1TimelineLinkIdRoute:
    unauthenticatedPublishedV1TimelineLinkIdRoute,
  unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRoute:
    unauthenticatedExportV1LoopVisualizationDashboardDashboardIdPngRouteRoute,
  unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRoute:
    unauthenticatedExportV1LoopVisualizationDashboardDashboardIdSvgRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePdfRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlanePngRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdSwimlaneSvgRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePdfRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelinePngRouteRoute,
  unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRoute:
    unauthenticatedExportV1LoopVisualizationViewViewIdVisualizationVisualizationIdTimelineSvgRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
